<template>
	<div id="courseInfo">
		<div class="courTit">
			<h1>
				<p>{{courseData.course.title}}</p>
				<span v-if="courseData.course.title && hideType === 3">{{courseData.course.course_type_format}}</span>
			</h1>
			<div class="jindu" v-if="courseData.score.total_score && hideType === 3">
				<i class="iconfont">&#xe7b0;</i>
				平时分：{{courseData.score.total_score.current_total > 100 ? 100 : courseData.score.total_score.current_total}}分 / {{courseData.score.total_score.total}}分
			</div>
			<div class="feedback" @click="notify">
				<i class="iconfont">&#xe618;</i>
				反馈
			</div>
			<!-- <div class="chengji">成绩获取：0.0分/共100.0分</div> -->
		</div>
		<div class="courseConBox">
			<ul class="ke_menu" v-loading="course_loading">
				<li v-for="(item,i) in keMenu" v-if="keMenu_show(item.show)" :key="i" @click="menuClick(i,item.boxId)" :class="menuNum==i?'act':''">
					<i class="iconfont" v-html="item.icon"></i>
					{{item.title}}
				</li>
			</ul>
			<div :style="menuBox=='jieshao'?'display:block':''" class="keInfoBox">
				<div class="jieshao">
					<p class="desc" v-html="courseData.course.render_desc"></p>
				</div>
			</div>
			<div :style="menuBox=='shipin'?'display:block':''" class="keInfoBox">
				<div v-if="courseData.chapters.length>0">
					<div class="vInfoBox">
						<div v-show="playerOptions.sources[0].src" class="vleftCon" @contextmenu.prevent="menuPlayer()" v-loading="vloading">
							<video-player id="courseVideo" class="courseVideo" ref="videoPlayer" v-if="videoSh"
							:class="thisPlayVideoSt?'':'prohibit'"
							:playsinline="true"
							:options="playerOptions"
							:events="['seeking','seeked']"
							@seeking="videoSeeking" @seeked="videoSeeked"
							@play="onPlayerPlay($event)"
							@pause="onPlayerPause($event)"
							@ended="onPlayerEnded($event)"
							@waiting="onPlayerWaiting($event)"
							@playing="onPlayerPlaying($event)"
							@loadeddata="onPlayerLoadeddata($event)"
							@timeupdate="onPlayerTimeupdate($event)"
							@canplay="onPlayerCanplay($event)"
							@canplaythrough="onPlayerCanplaythrough($event)"
							@statechanged="playerStateChanged($event)"
							@ready="playerReadied"></video-player>
						</div>
						<div v-if="!playerOptions.sources[0].src" class="vleftCon nodata">
							请选择章节视频播放
						</div>
						<div class="vrightCon">
							<div class="jieTxt">
								<div class="nowplay" v-if="v_zhang_tit">
									<div class="playSt">
										<img class="vplayImg" :src="videoPlay_img">正在播放
										<el-select class="resolution_switcher" v-model="resolution_val" placeholder="请选择"
										 @change="resolution_sw_change"
										 size="small">
											<el-option
											v-for="item in resolution_options"
											:key="item.value"
											:label="item.label"
											:value="item.value">
											</el-option>
										</el-select>
									</div>
									<p class="zhangTit">{{v_zhang_tit}}</p>
									<p class="jieTit">{{v_jie_tit}}</p>
								</div>
								<div v-if="next_video.zhang" class="nextplay" :class="next_video.zhang.id == 0 ?'novideo':''">
									<div class="nextVideo" @click="nextVideo">
										<i class="iconfont">&#xe662;</i>
										<font>{{next_video.zhang.title?"播放下一节":"无更多视频"}}</font>
									</div>
									<p class="zhangTit">{{next_video.zhang.title}}</p>
									<p class="jieTit">{{next_video.jie.title}}</p>
								</div>
							</div>
							<ul class="jieMsg">
								<li v-if="hideType === 3"><i class="iconfont">&#xe636;</i>课程总分：{{courseData.score.total_score.total}}</li>
								<li v-if="hideType === 3"><i class="iconfont">&#xe641;</i>已获总分：{{courseData.score.total_score.current_total > 100 ? 100 : courseData.score.total_score.current_total}}</li>
								<li v-if="hideType === 3">
									<i class="iconfont">&#xe600;</i>视频完成数：
									{{courseData.course.video_finish_number}}&nbsp;/&nbsp;{{courseData.course.videos_count}}
								</li>
								<li class="time"><i class="iconfont" @click="close_blur_v">&#xe675;</i>学习时长：<font>{{video_study_time}}</font></li>
								<li v-if="hideType === 3"><el-checkbox v-model="unfinished">仅显示未完成课程视频</el-checkbox></li>
							</ul>
						</div>
					</div>
					<dl class="shipinList">
						<dd v-if="course" v-for="(item,i) in course.chapters" :key="i" :class="spListSh==i?'show':''" @click="spListSw(i, $event)">
							<p v-if="course.videos[item.id]" @click="moveZhang($event)" class="bigtit">{{item.title}}（{{ c_v_num(course.videos[item.id]) }}）<i class="iconfont">&#xe610;</i></p>
							<ul>
								<li
								 v-if="video.duration && course.videos[item.id] && (unfinished? !progressCompute(video, 'bool') : true)"
								 v-for="(video,i) in course.videos[item.id]" :key="i"
								 :class="playVid==video.id?'act':''"
								 @click="getVideo(video, i, item)">
									<div v-if="hideType === 3">
										<el-progress :stroke-width="3" type="circle" :percentage="progressCompute(video)" :width="36" :color="progressCompute(video, 'color')" class="baifen"
										 v-if="!progressCompute(video, 'bool')"></el-progress>
										<el-progress :stroke-width="3" type="circle" :percentage="100" :width="36" :color="progressCompute(video, 'color')" class="baifen" v-else status="success"></el-progress>
									</div>
									<p>{{video.title}}</p>
									<div class="jie_right">
										<i class="iconfont play">&#xe662;</i>
										<img class="vplayImg" :src="videoPlay_img">
										<font>时长：{{parseInt(video.duration/60) + " : " + ( (video.duration%60) < 10 ? '0' + video.duration%60 : video.duration%60)}}</font>
										<!-- <font v-if="hideType === 3">需学习时长&nbsp;{{secondsFormat(video.need_study_time, {format:"M分钟"})}}</font> -->
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
				<div v-else class="nodata">
					<img :src="nodataImg">
					<p>待更新</p>
				</div>
			</div>
			<div :style="menuBox=='ziliao'?'display:block':''" class="keInfoBox pdfBox">
				<div v-if="pdfData.list.length>0">
					<div class="pdfPlayBox" v-show="pdfSh" v-loading="pdfload">
						<h2 class="pdftit">{{pdftit}}</h2>
						<iframe id="pdfCon" ref="iframe" :src="ifSrc+pdfsrc" width="100%" height="680"></iframe>
					</div>
					<ul class="jieMsg">
						<li v-if="hideType === 3 && pdfData.need_finish_number > 0"><i class="iconfont">&#xe636;</i>课程总分：{{courseData.score.total_score.total}}</li>
						<li v-if="hideType === 3 && pdfData.need_finish_number > 0"><i class="iconfont">&#xe641;</i>已获总分：{{courseData.score.total_score.current_total > 100 ? 100 : courseData.score.total_score.current_total}}</li>
						<li>
							<i class="iconfont">&#xe600;</i>课件完成数：
							{{courseData.course.attach_finish_number}}&nbsp;/&nbsp;{{pdfData.need_finish_number}}
						</li>
						<li class="time"><i class="iconfont">&#xe675;</i>学习时长：<font>{{chapters_study_time}}</font></li>
					</ul>
					<div class="ziliaoList">
						<ul>
							<li v-for="(item,i) in pdfData.list" :key="i" :class="pdfPlay.id==item.id?'act':''" @click="getPdf(item, $event, i)">
								<!-- <i class="iconfont">&#xe762;</i> -->
								<div v-if="hideType === 3 && item.need_study_time" style="display:inline-block;display: inline-block;float: left;margin-top: 11px;margin-right: 10px">
									<el-progress :stroke-width="3" type="circle" :percentage="progressCompute(item)" :width="36" :color="progressCompute(item, 'color')" class="baifen" v-if="!progressCompute(item, 'bool')"></el-progress>
									<el-progress :stroke-width="3" type="circle" :percentage="100" :width="36" :color="progressCompute(item, 'color')" class="baifen" v-else status="success"></el-progress>
								</div>
								<i v-else class="iconfont">&#xe762;</i>
								<div class="pdfTitle">
									<p>{{item.name}}</p>
									<font class="need_time">已学习时长&nbsp;&nbsp;{{ secondsFormat(item.attach_watch_record[0] ? item.attach_watch_record[0].study_seconds : 0, {format:"H时M分S秒"}) }}</font>
									<!-- <font v-if="hideType === 3" class="need_time">需学习时长&nbsp;{{secondsFormat(item.need_study_time, {format:"M分钟"})}}</font> -->
								</div>
								<div class="zl_rightBox" :class="hideType === 3 ? '':'muban'">
									<div class="zl_rightBox_btn download_btn" @click.stop="window_open(item)"><i class="el-icon-download"></i>&nbsp;下载</div>
									<div v-if="item.extension!='pdf'" :class="'zl_rightBox_btn see_btn'"><div class="iconfont see_btn_icn">&#xe669;</div>查看</div>
									<div v-else :class="pdfPlay.id==item.id?'zl_rightBox_btn zl_rightBox_btn_look':'zl_rightBox_btn'"><div class="iconfont see_btn_icn">&#xe669;</div>查看</div>
									<!-- <div :class="pdfPlay.id==item.id?'zl_rightBox_btn see_btn':'zl_rightBox_btn'"><div class="iconfont see_btn_icn">&#xe669;</div>查看</div> -->
									<!-- <el-button type="warning">下载</el-button> -->
									<!-- <el-button type="warning">查看</el-button> -->
									<!-- <span class="iconfont">&#xe637;</span>
									<font class="study_time">已学习时长&nbsp;&nbsp;{{ secondsFormat(item.attach_watch_record[0] ? item.attach_watch_record[0].study_seconds : 0, {format:"H时M分S秒"}) }}</font>
									<div v-if="hideType === 3" style="display:inline-block;">
										<el-progress :stroke-width="3" type="circle" :percentage="progressCompute(item)" :width="36" :color="progressCompute(item, 'color')" class="baifen" v-if="!progressCompute(item, 'bool')"></el-progress>
										<el-progress :stroke-width="3" type="circle" :percentage="100" :width="36" :color="progressCompute(item, 'color')" class="baifen" v-else status="success"></el-progress>
									</div> -->
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-else class="nodata">
					<img :src="nodataImg">
					<p>待更新</p>
				</div>
			</div>
			<div :style="menuBox=='tiku'?'display:block':''" class="keInfoBox" v-loading='bank_load'>
				<div class="tikuBox" v-if="questionBank.length">
					<el-button size="small" style="float: right;" @click="join_wrong_question_book()">错题本</el-button>
					<!-- <div class="questionBank simulation" v-if="questionBank.simulation.length">
						<h2>模拟题库</h2>
						<ul class="questionList">
							<li v-for="(item,index) in questionBank.simulation">
								<i class="iconfont">&#xe66c;</i>
								<div class="qInfo">
									<div class="qTitle">{{item.title}}</div>
									<dl>
										<dd>题数：{{item.q_num}}</dd>
										<dd>考试次数：<font>{{item.exams_num}}</font>/{{item.exams_max || '不限次'}}</dd>
									</dl>
								</div>
								<div class="q_open" @click="join_exercise(item, 'simulation')">开始答题</div>
							</li>
						</ul>
					</div> -->
					<div class="questionBank real" v-for="(questionBank_item,questionBank_i) in questionBank">
						<h2>
							{{questionBank_item.title}}
							
						</h2>
						<ul class="questionList">
							<li v-for="(item,index) in questionBank_item.exercise">
								<i class="iconfont">&#xe66b;</i>
								<div class="qInfo">
									<div class="qTitle">{{item.title}}</div>
									<dl>
										<dd>考试次数：{{item.exams_num}}/{{item.exams_max || '不限次'}}</dd>
										<!-- <dd>最后一次得分：{{item.last_score}}分</dd> -->
									</dl>
								</div>
								<div class="q_open" @click="join_exercise(item, 'real')">开始答题</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="nodata" v-else>
					<img :src="nodataImg">
					<p>待更新</p>
				</div>
			</div>
			<div :style="menuBox=='zuoye'?'display:block':''" class="keInfoBox">
				<div class="kaoshiBox" v-show="!tab_bol">
					<el-table :data="kaoshiList" class="kaoshiTab">
						<el-table-column prop="title" align="center" label="考试名称" width="240">
							<template slot-scope="scope">
								<p v-if="scope.row.makeup_id>0" type="primary">{{scope.row.title}}<span style="color:red;">(补考)</span></p>
								<p v-else>{{scope.row.title}}</p>
							</template>
						</el-table-column>
						<el-table-column prop="start_time" align="center" label="考试时间" :formatter="timeFn" width="200"></el-table-column>
						<el-table-column prop="address" align="center" label="考试地点" :formatter="addressFn" width="100"></el-table-column>
						<el-table-column prop="status" align="center" label="状态" :formatter="statusFn" width="80"></el-table-column>
						<el-table-column prop="score" align="center" label="得分" width="80"></el-table-column>
						<el-table-column prop="remark" align="center" label="备注" :formatter="markTxt">
							<!-- 查看详情 -->
							<template slot-scope="scope">
								<el-button v-if="scope.row.remark!=''" type="primary" @click="kaoshibeizhu(scope.row.remark)">查看详情</el-button>
								<p v-else>-</p>
							</template>
							
						</el-table-column>
						<el-table-column align="center" label="操作" width="160">
							<template slot-scope="scope">
								<!-- <p v-if="scope.row.exam_status==undefined" :class="tabBtnClas(scope)" @click.prevent="join_kaoshi(scope, scope.$index, courseData.exam)">{{tabCtrlText(scope.row.status)}}</p>
								<p v-else :class="tabBtnClas2(scope)" @click.prevent="join_kaoshi2(scope, scope.$index, courseData.exam)">{{tabCtrlText2(scope.row)}}</p> -->
								<!-- <p :class="tabBtnClas(scope)" @click.prevent="join_kaoshi(scope, scope.$index, courseData.exam)">{{tabCtrlText(scope.row.status)}}</p> -->
								<p :class="tabBtnClas(scope)" @click.prevent="jinrukaoshi(scope, scope.$index, courseData.exam)">{{tabCtrlText(scope.row)}}</p>
								<p v-if="scope.row.test_count!=0" class="joinBtn" @click.prevent="join_kaoshi2(scope)">查看结果</p>
								
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flow_path_f" v-show="tab_bol">
					<div v-if="tab_i==1">
						<div class="flow_path_h2">考试流程说明</div>
						<div class="flow_path">
                		    <div class="flow_path_thread">
                		        <div class="flow_num">1</div>
                		        <div class="flow_text">
                		            <div class="flow_hed">身份验证</div>
                		            <div class="flow_tit">点击“开始考试”后，系统会进入人脸识别身份验证</div>
                		        </div>
                		    </div>
                		    <div class="thread">
                		    </div>
                		    <div class="flow_path_thread">
                		        <div class="flow_num">2</div>
                		        <div class="flow_text">
                		            <div class="flow_hed">确认信息</div>
                		            <div class="flow_tit">确认个人信息是否正确，如不正确请及时上报</div>
                		        </div>
                		    </div>
                		    <div class="thread">
                		    </div>
                		    <div class="flow_path_thread">
                		        <div class="flow_num">3</div>
                		        <div class="flow_text">
                		            <div class="flow_hed">开始考试</div>
                		            <div class="flow_tit">完成身份验证后进入考试答题界面</div>
                		        </div>
                		    </div>
                		    <div class="thread">
                		    </div>
                		    <div class="flow_path_thread">
                		        <div class="flow_num">4</div>
                		        <div class="flow_text">
                		            <div class="flow_hed">完成考试</div>
                		            <div class="flow_tit">答题时间结束或完成所有试题后，点击交卷按钮完成考试</div>
                		        </div>
                		    </div>
                		</div>

						<div class="flow_path_btn">
							<div class="flow_path_set" @click="describe_face_verify_request()">开始考试</div>
						</div>
					</div>
					<div v-if="tab_i==2">
						<div class="flow_path_h2">身份验证</div>
						<div class="flow_path_h3">请正面对摄像头，保持光线充足</div>
						<div class="con_round">
                		    <div class="round_white">
                		        <img style="width: 100%" :src="temporarily_url" alt="">
                		        <div class="identify_status" :style="face_bol?'':'background-color: #ff5959;'">
                		            {{identify_txt}}
                		        </div>
                		    </div>
                		</div>
						<div class="flow_path_btn" style="margin-top: 50px;">
							<div class="flow_path_set" :class="face_bol?'':'not_set'" @click="set_tab('add')">下一步</div>
						</div>
					</div>
					<div v-if="tab_i==3">
						<div class="flow_path_h2">确认信息</div>
						<div class="flow_path_h3">如果信息不正确，请及时告知考试管理员，避免影响个人考试成绩 </div>
						<div class="confirm">
							<div class="flow_path_head_sculpture">
								<img :src="temporarily_url" alt="" style="width: 100%;margin-top: 69%;transform: translateY(-50%);">
							</div>
							<div class="flow_path_data">
								<div class="flow_path_data_name">
									<span>学生姓名：</span>{{exam_name}}
								</div>
								<div class="flow_path_data_name">
									<span>身份证号：</span>{{exam_ic}}
								</div>
							</div>
						</div>
						<div class="flow_path_btn" style="margin-top: 50px;">
							<div class="flow_path_set" @click="open_text()">开始考试</div>
						</div>
					</div>
				</div>
				<!-- <div class="nodata">
					<img :src="nodataImg">
					<p>待更新</p>
				</div> -->
			</div>
			<!-- 考试查看详情 -->
			<el-dialog
			  title="备注详情"
			  :visible.sync="beizhuxiangqing"
			  width="30%" >
			  <span v-html="beizhuxiangqingtext"></span>
			</el-dialog>
			<!-- 我的笔记 -->
			<div :style="menuBox=='biji'?'display:block':''" class="keInfoBox biji" v-loading="bijijiazai">	
				<!-- <div v-if="pdfData.list.length>0"> -->
					<ul :class="bijidata.list.length==0?'jieMsg jieMsg_b':'jieMsg'">
						<!-- <li v-if="hideType === 3"><i class="iconfont">&#xe636;</i>课程总分：{{courseData.score.total_score.total}}</li>
						<li v-if="hideType === 3"><i class="iconfont">&#xe641;</i>已获总分：{{courseData.score.total_score.current_total > 100 ? 100 : courseData.score.total_score.current_total}}</li>
						<li v-if="hideType === 3">
							<i class="iconfont">&#xe600;</i>笔记总分：
							{{courseData.score.notes.notes_score}}&nbsp;/&nbsp;{{courseData.score.notes.notes_total}}
						</li> -->
						<li class="sou"><el-button type="primary" icon="el-icon-edit" @click="bijitangchu()">写笔记</el-button></li>
					</ul>
					<div class="pdfPlayBox" v-show="pdfSh">
						<h2 class="pdftit">{{pdftit}}</h2>
						<iframe id="pdfCon" ref="iframe" :src="ifSrc+pdfsrc" width="100%" height="680"></iframe>
					</div>
					<!-- 笔记内容 -->
					<div v-show="bijidata.list.length==0" class="nodata">
						<img :src="nodataImg">
						<p>待更新</p>
					</div>
					<div v-for="(item,index) in bijidata.list" :key="item.id" :class="bijidata.list.length==index+1?'bijineirong bijineirongbd0':'bijineirong'">
						<div class="bijineirong_left">
							<div class="biaoti">
								<div class="biaoti_left"><span>{{item.title}}</span></div>
								<div class="biaoti_right"><a href="" @click.prevent="delBiji(item.id)">删除</a><a href="" @click.prevent="bianjibiji(item.id)">编辑</a></div>
							</div>
							<div>
								<p :class="item.pneirong?'pneirong':'show'">
								{{item.content}}
								</p>
								<div>
									<div class="zhankai" @click="expandeClick(index)" v-show="item.zhankai">{{item.zhanshi}}<i :class="item.zhanshi=='收起全文'?'iconfont dao':'iconfont'">&nbsp;&#xe610;</i></div>
									<!-- <div class="expande-button" @click="expandeClick">收起</div> -->
								</div>
							</div>
							<div class="riqi">{{item.created_at}}</div>
						</div>
					</div>
					<!-- <div :class="jiazaiCompute('class')" @click="jiazaigengduo()">{{jiazaiCompute('text')}}</div> -->
				<!-- </div> -->
				<!-- <div v-else class="nodata"> -->
					<!-- <img :src="nodataImg"> -->
					<!-- <p>待更新</p> -->
				<!-- </div> -->
			</div>
			<!-- 笔记对话框 -->
			<el-dialog title="写笔记" :visible.sync="bijidialogVisible" width="40%" v-loading="bijidialogload" class="taolunduihua" :close-on-click-modal="false">
				<el-input v-model="bijicanshu.title" style="width:100%;margin-bottom:20px;" placeholder="请输入标题"></el-input>
				<el-input v-model="bijicanshu.content" style="width:100%;" placeholder="内容" type="textarea" :rows="12" class="nei"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addBiji(bijiwancheng)">完成</el-button>
				</span>
			</el-dialog>
			<!-- 课堂讨论 -->
			<div :style="menuBox=='taolun'?'display:block':''" class="keInfoBox taolun" v-loading="taolunjiazai">
			<!-- <div v-if="pdfData.list.length>0"> -->
				<ul class="jieMsg">
					<!-- <li v-if="hideType === 3"><i class="iconfont">&#xe636;</i>课程总分：{{courseData.score.total_score.total}}</li>
					<li v-if="hideType === 3"><i class="iconfont">&#xe641;</i>已获总分：{{courseData.score.total_score.current_total > 100 ? 100 : courseData.score.total_score.current_total}}</li>
					<li v-if="courseData.score.discuss && hideType === 3">
						<i class="iconfont">&#xe600;</i>讨论得分：
						{{courseData.score.discuss.discuss_score}}&nbsp;/&nbsp;{{courseData.score.discuss.discuss_total}}
					</li> -->
				</ul>
				<div>
					<el-radio-group v-model="radio1" @change="taoluntab">
						<el-radio-button label="我的讨论">我的讨论</el-radio-button>
						<el-radio-button label="我的回复">我的回复</el-radio-button>
						<el-radio-button label="所有讨论">所有讨论</el-radio-button>
					</el-radio-group>
					<el-button type="primary" class="fabiao" @click="taoluntangchu()"><i class="iconfont">&#xe60c;</i> 发表讨论</el-button>
				</div>
				<!-- 我的讨论 -->
				<div class="taolunneirong" v-show="radio1==='我的讨论'">
					<div v-if="myDiscdata.list.length===0" class="nodata">
						<img :src="nodataImg">
						<p>待更新</p>
					</div>
					<div v-for="(item,index) in myDiscdata.list" :key="item.id" class="taolunzhu">
						<div class="taolunbiaoti">
							<div class="biaotigao"><span class="sp1">{{item.title}}</span></div>
							<div class="neirong">
								{{item.content}}
							</div>
							<div class="riqi">
								{{item.created_at}}
								<a :class="item.pinglun&&gengduodata2.reply.length>0?'sp2 bull':'sp2'" @click="zhankai(index,item.id)">
									<i class="el-icon-chat-dot-square">&nbsp;</i>{{item.reply_count}}
								</a>
							</div>
						</div>
						<!-- 回复 -->
						<div class="huifu" v-show="item.pinglun&&gengduodata2.reply.length>0">
							<div v-for="(item2) in gengduodata2.reply" :key="item2.id" class="huifuzhu">
								<div class="huifuneirong">
									<span>{{item2.user[0].nick_name}}：</span>
									{{item2.content}}
								</div>
								<div class="riqi">{{item2.created_at}}</div>
							</div>
							<div class="chakan" v-show="replydata.reply.length>3" @click="chakangduo2()">
								{{chavule}}<i :class="!chakang?'iconfont dao':'iconfont'">&nbsp;&#xe610;</i>
							</div>
						</div>
					</div>
				</div>
				<!-- 我的回复 -->
				<div class="taolunneirong" v-show="radio1==='我的回复'">
					<div v-if="huifudata.list.length===0" class="nodata">
						<img :src="nodataImg">
						<p>待更新</p>
					</div>
					<div class="taolunzhu taolunhuifu" v-for="item in huifudata.list" :key="item.id">
						<div class="taolunbiaoti ">
							<!-- <div><span class="sp1">666</span></div> -->
							<div class="neirong biaotigao">
								{{item.content}}
							</div>
							<div class="riqi">{{item.created_at}}</div>
						</div>
						<div class="huifu" @click="huifutiaozhuan(item.discuss_id)">
							<div class="huifuzhu2">
								<div class="huifuneirong">
									回复
									<span>{{item.discuss[0].user[0].nick_name}}：</span>
									<span class="biaoti">{{item.discuss[0].title}}</span>-
									{{item.content}}
								</div>
								<div class="riqi">
									{{item.created_at}}
									<a class="sp2">
										<i class="el-icon-chat-dot-square">&nbsp;</i>{{data_total}}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 所有讨论 -->
				<div class="taolunneirong" v-show="radio1==='所有讨论'">
					<div v-if="allDiscdata.list_discuss.length===0" class="nodata">
						<img :src="nodataImg">
						<p>待更新</p>
					</div>
					<div v-for="(item,index) in allDiscdata.list_discuss" :key="index" class="taolunzhu">
						<div class="taolunbiaoti">
							<div :ref="'gaodu'+item.id" class="biaotigao"><span class="sp1">{{item.title}}</span></div>
							<div class="neirong">
								{{item.content}}
							</div>
							<div class="riqi"><span>{{item.user[0].nick_name}}</span>{{item.created_at}} <a :class="item.pinglun?'sp2 bull':'sp2'" @click="zhankai2(index,item.id)"><i class="el-icon-chat-dot-square">&nbsp;</i>{{item.reply_count}}</a></div>
						</div>
						<!-- 回复 -->
						<div class="huifu" v-show="item.pinglun">
							<el-form :inline="true" :model="formInline">
								<el-form-item>
									<el-input v-model="inputsiz" :style="inputDaxiao" @input="inputSize" placeholder="回复..."></el-input>
								</el-form-item>
								<el-form-item>
									<el-button :type="fasong" @click="fasonghuifu(index,item.id,item.user[0].nick_name)">发送</el-button>
								</el-form-item>
							</el-form>
							<div v-for="(item2,index2) in gengduodata.reply" :key="index2" class="huifuzhu" v-if="index2<cha">
								<div class="huifuneirong">
									<span>{{item2.user[0].nick_name}}:</span>
									{{item2.content}}
								</div>
								<div class="riqi">{{item2.created_at}}</div>
							</div>
							<!-- 查看更多 -->
							<div class="chakan" v-show="themedata.reply.length>3" @click="chakangduo()">
								{{chavule}}<i :class="!chakang?'iconfont dao':'iconfont'">&nbsp;&#xe610;</i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 课堂讨论对话框 -->
			<el-dialog title="发表讨论" :visible.sync="taolundialogVisible" width="40%" class="taolunduihua" :close-on-click-modal="false">
				<el-input v-model="taolunfasong.title" style="width:100%;margin-bottom:20px" placeholder="请输入标题"></el-input>
				<el-input v-model="taolunfasong.content" style="width:100%;color:red;" placeholder="内容" type="textarea" :rows="12" class="nei"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="fabiaitaolun()">完成</el-button>
				</span>
			</el-dialog>
			<!-- 摄像头确认对话框 -->
			<el-dialog
			  title="请确认"
			  :visible.sync="camera_open"
			  width="30%">
				<span>请确认摄像头是否正常使用</span>
				<div>
					<video ref="mediaElement" id="videoCamera" autoplay style="width:100%"></video>
					<!-- <canvas style="display:none;" id="canvasCamera"></canvas>
					<div v-if="imgSrc" class="img_bg_camera">
						<img :src="imgSrc" alt="" class="tx_img">
					</div> -->
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="camera_open_hidden">否</el-button>
					<el-button type="primary" @click="join_kaoshi(jinrukaoshidata)">是</el-button>
				</div>
			</el-dialog>

			<!-- 错题本选择 -->
			<el-dialog
			  title="提示"
			  :visible.sync="wrong_question_book_dialog"
			  width="30%"
			  >
			  	<el-form>
					<el-form-item label="总错题数" :label-width="'70px'">
						{{err_quan_sum}}
  				  		<!-- <el-input v-model="err_quan_sum" type="number" autocomplete="off" readonly></el-input> -->
  				  	</el-form-item>
  					<el-form-item label="错题数" :label-width="'70px'">
  						<el-input v-model="quantity" type="number" autocomplete="off"></el-input>
  					</el-form-item>
  				</el-form>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="wrong_question_book_dialog = false">取 消</el-button>
			    <el-button type="primary" @click="wrong_question_book_dialog_fn()">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
		<el-dialog title="反馈" :visible.sync="dialog_feedback">
		  	<el-form>
				<el-input type="textarea" v-model="feedbackCreated_content.content" :rows="4" autocomplete="off"></el-input>
		  	  	<!-- <el-form-item label="活动名称" :label-width="120">
		  	  	  	
		  	  	</el-form-item> -->
		  	</el-form>
		  	<div slot="footer" class="dialog-footer">
		  	  	<el-button @click="dialog_feedback = false">取 消</el-button>
		  	  	<el-button type="primary" @click="notify_click()">确 定</el-button>
		  	</div>
		</el-dialog>
	</div>
</template>

<script>
let token, serverSrc, qianzui;
//记录用户观看视频时长
function recordFn(that, option){
	let options = Object.assign({
		thisTime: 1,
		postTime: 1,
		type: 0,
		success: '',
		finish_success: '',
		st: '',
	},option)
	let video_data = that.courseData.videos[that.playCid][that.vidArrNum]		//当前播放视频的数据
		,user_video_record = video_data.user_video_record					//播放记录
		,learn_progress = video_data.student_learn_progress					//进度完成情况
	// console.log(options.thisTime+'%'+options.postTime+'==' + (options.thisTime%options.postTime) + (options.type==0?'用户播放':'视频播放'))
	console.log(options.st);
	
	if(options.thisTime == options.postTime){			// 每隔一段时间传一次用户真实观看的时长
		serverSrc = that.global.serverSrc
		qianzui = that.global.qianzui
		//获取课程信息
		let url = serverSrc + qianzui + "/video/" + that.playVid + "/record"
			,study_time = 0;
		if(options.type == 0){
			study_time = options.postTime
		}else if(options.type == 1){
			study_time = that.uViodePlayTime
		}
		if(that.video_record_run){
			console.log('防止重复触发视频记录接口');
			return false
		}
		that.video_record_run = true
		that.$ajax.post(
			url,
			that.$qs.stringify({
				// 触发提交时，视频进度此时的进度（单位：秒）
				duration: that.ViodePlayPostTime
				// 此次提交观看的时长
				,study_time: study_time
				// 课程ID
				,course_id: that.cInfo.courseId			
			}),
			{ isRequesting: false}
		)
		.then(res => {
			that.video_record_run = false
			let resData = res.data
			if(resData.code == 0){

				// 触发记录后更新该视频的观看时长
				that.course.videos[that.playCid][that.vidArrNum].user_video_record[0].study_seconds = resData.data.study_time
				// 记录学生观看时长，达到触发接口秒数后 或 观看新的视频时，清零重算
				that.user_video_record_time = 0

				// 接口运行结束
				if(resData.data.is_finish == 1 && (learn_progress.length == 0 || learn_progress[0].is_finish == 0)){
					let score_videos = that.courseData.score.videos,
						total_score = that.courseData.score.total_score

					// 获取用户课程进度
					that.get_user_course_study_info().then(res=>{
						//更新已获得总分
						total_score.current_total = res.score.videos.score

						//更新视频完成数
						that.courseData.course.video_finish_number = res.score.videos.finish_count

						//更新视频学习时长
						that.courseData.course.video_study_time = res.score.videos.has_study_time
					})
					//记录该视频已完成学习
					if(learn_progress.length > 0){
						learn_progress[0].is_finish = 1
					}else{
						learn_progress[0] = { is_finish: 1 }
					}
					
					//成考模板完成视频的提示
					if(that.hideType === 3){
						//暂停视频
						that.$refs.videoPlayer.player.pause()
						// 下一个视频的章的ID
						let chapid = that.next_video.zhang.id
						// 触发超深色加载Loading遮住内容
						let loading = that.$loading({
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.95)'
						});
						//弹窗提示视频已经学习完
						that.$msgbox({
							title: '温馨提示',
							confirmButtonText: '确定',
							showClose: false,
							customClass: 'confirm_msgbox',
							confirmButtonClass: "confirm_msgbox_btn",
         					message: chapid == 0 ? '本小节学习已完成，点击确定回到首页' : '本小节学习已完成。',
          					showCancelButton: false,
							type: 'success',
							callback: function(action, instance){
								// action 的值为'confirm', 'cancel'或'close', 
								// instance 为 MessageBox 实例，可以通过它访问实例上的属性和方法
								// if(action == 'confirm'){
								// 	// 点击确定触发观看下一个视频函数
								// 	that.nextVideo()
								// }
							},
							// MessageBox 关闭前的回调，会暂停实例的关闭
							beforeClose: function(action, instance, done){
								// action 的值为'confirm', 'cancel'或'close'；
								// instance 为 MessageBox 实例，可以通过它访问实例上的属性和方法；
								// done 用于关闭 MessageBox 实例

								// 判断是否为最后一个视频
								if(chapid == 0){
									// 返回到首页
									that.$router.push({ path: '/web/index/', })
								}
								// 关闭加载loading
								loading.close()
								// 关闭弹窗
								done()
							}
						});
						// 自动播放下一个视频，0为关闭，1为开启
						if(that.auto_play_next_video){
							// 弹出来窗户 倒计时5秒 然后关闭窗口 继续播下一个
							setTimeout(()=>{
								// 关闭弹窗
								$(".confirm_msgbox .confirm_msgbox_btn").click()
								// 触发观看下一个视频函数
								that.nextVideo()
								function playVideo() {
									console.log(that.$refs.videoPlayer.player.isReady_);
									// 播放视频
									if (that.$refs.videoPlayer.player.isReady_) {
										// that.$nextTick(()=>{
											that.$refs.videoPlayer.player.play()
										// })
									}else{
										setTimeout(playVideo, 2000)
									}
								}
								setTimeout(playVideo, 2000)
							}, 5000)
						}
						//打开视频的拖拽进度条开关
						that.thisPlayVideoSt = true
					}
					if(options.finish_success && typeof options.finish_success === 'function') options.finish_success(res)
				}
				if(options.success && typeof options.success === 'function') options.success(res)
				that.$forceUpdate();
			}else{
				that.$message.error('请求失败，请联系管理员！');
			}
		})
		.catch(e => {
			that.video_record_run = false
			console.log(e);
			that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~');
		});
	}
}

//记录用户观看PDF时长
function pdfTimeFn(that){
	//记录课件阅读时长
	let pdfPlayId = that.pdfPlay.id,
		pdfPlayNum = that.pdfPlay.num
	if(pdfPlayId == 0 || pdfPlayId == "0" || pdfPlayNum == undefined){
		return false
	}else{
		clearInterval(that.global.pageTimer['pdfPlayTimeOut'])
		let url = that.global.serverSrc + that.global.qianzui + "/attach/" + pdfPlayId + "/record"
		that.global.pageTimer['pdfPlayTimeOut']=setInterval(() => {
			let clear = false
			that.course.course.chapters_study_time++								//记录课件学习时长
			// console.log('pdfTime'+that.pdfPlayPostTime)
			// that.pdfData.list[pdfPlayNum].attach_watch_record[0].study_seconds++
			
			//实时计算课程圆形进度条
			let video_data = that.pdfData.list[pdfPlayNum],							//当前播放课件的数据
				attach_watch_record = video_data.attach_watch_record,				//播放记录
				need_time = video_data.need_study_time								//课件需观看时长
			if(attach_watch_record.length > 0){
				attach_watch_record[0].study_seconds++								//记录课件进度
			}
			//如果课件已学习到对应的时间，则判断该课件已学习完成及提醒
			if(attach_watch_record[0].study_seconds == need_time){
				clear = true									//把完成的参数回传
				that.course.course.attach_finish_number++		//课件完成数+1
			}

			let pdfPlayPostTime = that.pdfData.list[pdfPlayNum].attach_watch_record[0].study_seconds		//获取当前课件实际观看时间
			if( pdfPlayPostTime % that.pdfPlayTime == 0 ){			//每隔10秒传一次用户真实观看的时长
				that.$ajax.post(
					url,
					that.$qs.stringify({
						duration: that.pdfPlayTime,
						course_id: that.cInfo.courseId,
					}),
				)
				.then(res => {
					let resData = res.data
					if(resData.code == 0){
						if(resData.data.is_finish == 0 && clear){
							//增加已获得总分
							let score_chapters = that.course.score.chapters,
								total_score = that.course.score.total_score
							total_score.current_total = (parseFloat(total_score.current_total) + parseFloat(score_chapters.chapter_single_score)).toFixed(1)
							if(total_score.current_total > 100){
								total_score.current_total = 100
							}
						}
					}else{
						that.$message.error('请求失败，请联系管理员！');
					}
				})
				.catch(e => {
					console.log(e);
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~');
				});
			}
		},1000)
	}
}
import * as rts from 'aliyun-rts-sdk';
export default {
	data () {
		return {
      		temp: this.temp.courseInfo,
			imgSrc: '',
        	thisCancas: null,
        	thisContext: null,
        	thisVideo: null,
			jinrukaoshidata:'',
			camera_open:false,
			beizhuxiangqing: false,
			beizhuxiangqingtext:'',
			bijijiazai:false,
			taolunjiazai:false,
			videoPlay_img: this.global.oss_website+'/pc/images/course/videoPlay.gif'
			,ifSrc:this.global.serverSrc+"/web/pdfjs/web/viewer.html?file="
			,cInfo:this.$route.query
			,pdfsrc:""
			,keMenu:[{
				title:"视频课程"
				,boxId:"shipin"
				,icon:"&#xe621;"
				,show: this.temp.courseInfo.keMenu.shipin
			},{				//课程详情顶栏
				title:"课程介绍"
				,boxId:"jieshao"
				,icon:"&#xe6b2;"
				,show: this.temp.courseInfo.keMenu.jieshao
			},{
				title:"课程资料"
				,boxId:"ziliao"
				,icon:"&#xe61d;"
				,show: this.temp.courseInfo.keMenu.ziliao
			},{
				title:"我的笔记"
				,boxId:"biji"
				,icon:"&#xe692;"
				,show: this.temp.courseInfo.keMenu.biji
			},{
				title:"课程讨论"
				,boxId:"taolun"
				,icon:"&#xe640;"
				,show: this.temp.courseInfo.keMenu.taolun
			},{
				title:"题库练习"
				,boxId:"tiku"
				,icon:"&#xe623;"
				,show: this.temp.courseInfo.keMenu.tiku
			},{
				title:"考试安排"
				,boxId:"zuoye"
				,icon:"&#xe6a4;"
				,show: this.temp.courseInfo.keMenu.zuoye
			}]
			,menuNum: 0				//默认显示第一个
			,menuBox:this.$route.query.menuBox || "shipin"		//默认显示课程介绍
			,course_loading:true

			,spListSh:0				//默认显示第一章
			,spBaifenColor:"#faa95a"	//进度颜色
			
			,pdfSh:false
			,pdfload:true
			// ,pdfPlayPostTime:0
			,pdfPlayTime:10
			,pdftit:''
			,pdfPlay:{}

			,chaptersIdArr:[]				//存放章节ID的数组
			,vidArrNum:0					//章节下第几个视频
			,playCid:0
			,playVid:0
			,thisPlayVideoSt:true			// 拖拽进度条开关
			,cheat_drag: false				// 拖拽作弊开关
			,cheat_drag_status: 0				// 拖拽作弊(接口开关，0为关闭，1为开启)
			,cheat_sw_time: 180					// 观看视频超过当前时间既可打开作弊开关
			,cheat_watchType: 0				// 学生进度作弊类型
			,cheat_watchNeedTime: 0				// 学生进度作弊需学习时长
			,thisVideoDuration:0
			,vloading:true
			// ,uViodePlayPostTime:0
			,uViodePlayTime:5
			,ViodePlayPostTime:0			//视频进度
			// ,ViodePlayTime:10
			,videoSh:false
			,playerOptions:{		//播放器参数
				playbackRate:1,
				playbackRates: [],		//播放速度  0.7, 1.0, 1.5, 2.0
				autoplay: false,			//为true时，浏览器准备好时开始播放
				muted: false,			//默认情况下将静音
				loop: false,			//视频循环播放
				preload: 'auto',			//建议浏览器在video加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为
				language: 'zh-CN',			//播放器语言
				aspectRatio: '16:9',	//将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例
				fluid: true,	//当true时，video.js player将按比例缩放以适应容器
				flash: { hls: { withCredentials: false } },
        		html5: { hls: { withCredentials: false } },
				sources:[{
					type: "video/mp4",
					src: ""
				}],
				poster: "",
				width: document.documentElement.clientWidth,
				notSupportedMessage:"此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar:{
					currentTimeDisplay: true,
					timeDivider: true,			//当前时间和持续时间的分隔符
					durationDisplay:true,			//显示持续时间
					remainingTimeDisplay:true,		//是否显示剩余时间功能
					fullscreenToogle:true		//全屏按钮
				},
				playtimes:100, //视频观看起点
			}
			,v_zhang_tit:''
			,v_jie_tit:''
			,next_video:{}

			,pdfData:{
				list:[],
				total:0,
			},
			courseData:{
				course:{
					title:""
					,render_desc:""
					,video_study_time:''
					,videos_count:''
				}
				,score:{
					total_score:{},
					notes:{}
				}
				,chapters:{}
				,videos:{}
				,exam:[]
			},
			//讨论数据
			myDiscdata:{list:[]},
            replydata:{reply:[]},
            allDiscdata:{list_discuss:[]},
			themedata:{reply:[]},
			gengduodata:{reply:[]},
			gengduodata2:{reply:[]},
			huifudata:{list:[]},
			// 讨论tab切换
			radio1:"我的讨论",
			formInline:{
				user:''
			},
			// input大小
			inputDaxiao:"width:200px",
			// 发送按钮
			fasong:"",
			// 课堂讨论弹出框
			taolundialogVisible:false,
			// 课堂讨论发布
			taolunformInline:{
				user:''
			},
			// 评论展开
			// pinglun:false,
			//文本展开
			expande: true,
            needShowExpande: false,
			// 笔记弹出
			bijidialogVisible:false,
			bijidialogload:false,
			//讨论发送
			taolunfasong:{
				title: "",
				content: "",
				course_id:0
			},
			inputsiz:"",
			// 查看更多
			chakang:true,
			chavule:"查看更多",
			// 条数
			data_total:0,
			// 笔记列表
			bijidata:{list:[]},
			// 笔记参数
			bijicanshu:{
				title:'',
				content:''
			},
			// 笔记讨论进来只加载一次
			taolunOne:true,
			bijiOne:true,
			// 分数
			fenshu:true,
			// 笔记分数
			fenshu2:true,
			cha:3,
			// 笔记id
			bijiId:'',
			// 笔记完成
			bijiwancheng:'',
			changValue:null,
			// 判断内容
			zhanshi:'展开全文',
			pneirong:true,
			biji_now_page:1,	//当前笔记页数

			// 考试数据
			kaoshiList:[],
			camera:-1,

			//题库练习
			bank_load:true,
			chapters_show:0,
			questionBank:[],
			// questionBank:{
			// 	simulation:[],
			// 	real:[],
			// 	chapters: []
			// },
			// 本地流
			localStream:'',
			//考试流程说明索引
			tab_i:1,
			//考试流程显示
			tab_bol:false,
			//头像路径
			temporarily_url:'',
			face_bol:false, //是否通过
			identify_txt:'识别中',
			exam_name:'', //学生名字
			exam_ic:'', //学生身份证
			user_id:'', //学生id
			this_test_id:'', //考试id
			img_url:'',//人脸路径
			certified:false,//是否实名
			//错题本参数
			quantity:0,
			wrong_question_book_dialog:false,
			err_quan_sum:0,//错题数量

			pay_start_ad: 0,		// 开始播放前显示LOGO画面，0则关闭，1则开启
			pay_start_ad_time: 7,	// 开始播放前显示LOGO画面时间（最大100秒）
			//反馈内容
			feedbackCreated_content:{
				content:'',

			},
			//反馈弹窗
			dialog_feedback:false,
			// 仅显示未完成课程视频
			unfinished: false,
			fake_bug: false,		// 假BUG开关
			fake_finish_progre: 0,	// 需要达到的假完成进度
			// 判断视频记录接口是否处于运行中
			video_record_run: false,
			// 记录学生观看时长，达到触发接口秒数后 或 观看新的视频时，清零重算
			user_video_record_time: 0,

			// 分辨率
			resolution_options: [{
				value: '1',
				label: '标清'
			}],
			resolution_val: '1'
		}
	}
	,mounted:function(option){
		let that = this
		
		this.$store.dispatch('get_app_config').then(app_config=>{
			if(app_config && app_config.study && app_config.study.record){
				this.uViodePlayTime = app_config.study.record.video_interval
				this.pdfPlayTime = app_config.study.record.attach_interval
			}
		})

		token=this.$cookies.get("token")
		serverSrc=that.global.serverSrc
		qianzui=that.global.qianzui

		// 讨论
		// 课程id
		let query=this.$route.query;
		let lat = query.courseId;
		this.taolunfasong.course_id=lat
		//判断是否能学习
		this.$ajax.get(serverSrc + qianzui +"/member/check_course_can_study?course_id="+lat)
		.then((res)=>{
			let resData=res.data;
			if(resData.code==0){
				if (resData.data.result==2) {
					this.$message.warning("当前不在学习时间")
					this.$router.push({ path: '/web/index/', })
				}
			}else{
				this.$message.error(resData.message)
				// console.log(resData.message);
			}
		})

		this.$selfjs.getUserCallFn(this, res=>{
			let idcard = res.idcard
			this.exam_name=res.nick_name					//学生姓名
			this.exam_ic=idcard				         	//学生身份证
			this.user_id = res.id
			this.certified = res.certified
			// if (res.grade.cur_schedule) {
			// 	if ((Date.parse(res.grade.cur_schedule.end_date)+86400000<Date.parse(new Date()))||Date.parse(res.grade.cur_schedule.start_date)>Date.parse(new Date())) {
			// 		this.$message.warning("当前不在学习时间")
			// 		this.$router.push({ path: '/web/index/', })
			// 	}
			// }
			// 自动播放下一个视频
			this.auto_play_next_video = res.school.extra.study.required.auto_play_next_video
			// 判断视频和课件失焦暂停的开关
			this.leave_stop_play = res.school.extra.study.required.leave_stop_play == 1 ? true : false		// 0则关闭，1则开启
			// 接口作弊拖拽开关
			this.cheat_drag_status = res.school.extra.study.required.cheat_drag_status
			// 观看视频超过当前时间既可打开作弊开关(接口)
			this.cheat_sw_time = res.school.extra.study.required.cheat_drag_time
			// 开始播放前显示LOGO画面，0则关闭，1则开启
			this.pay_start_ad = res.school.extra.study.required.pay_start_ad
			// 开始播放前显示LOGO画面时间
			this.pay_start_ad_time = res.school.extra.study.required.pay_start_ad_time
			// 课程视频随机完成BUG，0或空则关闭，1则开启
			this.random_auto_complete = res.school.extra.study.required.random_auto_complete == 1 ? true : false
			// 课程视频完成达标后禁止观看视频，0或空则关闭，1则开启
			this.course_video_complete_restrict_pay = res.school.extra.study.required.course_video_complete_restrict_pay == 1 ? true : false
			// 当前院校ID
			this.school_id = res.school.school_id
		})

		if (query.tab_i) {
			that.tab_i = query.tab_i
			that.this_test_id = query.this_test_id
			that.menuBox = 'zuoye'
			this.getKaoshiList()
			that.tab_bol = true
			// 初始化url对象
        	var this_url = new URL(window.location.href);
        	// 解析response
        	var response = {}
			if (this_url.searchParams.get('response')) {
				response = JSON.parse(
        		    decodeURIComponent(this_url.searchParams.get('response'))
        		);
			}
			if (response.extInfo) {
				let data = {
					certifyId:response.extInfo.certifyId
				}
				this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/describe_face_verify",this.$qs.stringify(data))
				.then(res=>{
					// console.log(res);
					let resData=res.data.data;
					if(resData.Code=='200'){
						resData.ResultObject.MaterialInfo = JSON.parse(resData.ResultObject.MaterialInfo)
						// console.log(resData);
						if (resData.ResultObject.Passed=='T') {//通过
							// console.log(resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl);
							that.temporarily_url = resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl
							that.compare_face(resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl)
							// that.getBase64(null,resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl).then(result => {
							// 	that.upLoad(result,17)
							// });
						}else{//未通过
							this.identify_txt = '活体认证未通过'
							this.$message.error('认证未通过')
						}
					}else{
						this.identify_txt = '活体识别失败'
						this.$message.error(resData.Message)
					}
				}).catch(e => {
					console.log(e);
					this.identify_txt = '活体识别失败'
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			}	
		}

		//考试是否显示
		// console.log(this.hideType);
		// if(this.hideType===1){
		// 	this.keMenu[6].show = false
		// }
		// this.getMyDiscdata()
		
		// 无课程ID进课程详情页
		if(!this.cInfo.courseId){
			this.$alert('课程ID有误', '提示', {
				confirmButtonText: '确定',
				closeOnHashChange: false,
				showClose: false,
				callback: action => {
					// 返回首页
					this.$router.push('/web/' + this.$store.state.defaultIndex)
				}
			});
			return false;
		}
		//获取课程信息
		let url = serverSrc + qianzui + "/course/" + this.cInfo.courseId
		this.$ajax.get(url)
		.then((res)=>{
			that.course_loading = false
			let data=res.data
			if(data.code==0){
				let resData = data.data
				// console.log(resData);
				// if(!resData.course.is_current_term && this.hideType === 3&& !query.tab_i){
				// 	this.$alert('本课程非当前学期课程，学习不计算平时成绩。', '温馨提示');
				// }
				// 把视频的章节ID保存到章节ID数组里
				that.chaptersIdArr = Object.keys(resData.videos)
				// 章对象循环
				for(let vkey in resData.videos){
					let zhang = resData.videos[vkey]
					// 节的视频对象循环
					for(let v=0; v<zhang.length; v++){
						let video_item = zhang[v]
						let video_record = video_item.user_video_record
						if(video_record.length == 0){
							video_record[0] = {
								study_seconds:0,
								updated_at:"",
								video_id: video_item.id,
								watch_seconds:0
							}
						}
					}
				}
				// that.chaptersIdArr = chaptersIdArr
				// console.log(that.chaptersIdArr);
				that.courseData = resData
				// let k=0
				// 章对象循环
				for(let vkey in resData.videos){
					// 计算章的index
					let zhang_idx = resData.chapters.findIndex((item) => item.id == vkey)
					let chapter = resData.chapters.find((item) => item.id == vkey)
					let zhang = resData.videos[vkey]
					// 节的视频对象循环
					for(let v=0; v<zhang.length; v++){
						let video_item = zhang[v]
						// 定位最后看到的章节位置
						if(resData.last_watch.video && video_item.id == resData.last_watch.video.video_id){
							that.spListSh = zhang_idx
							that.getVideo(video_item, v, chapter)
						}
					}
					// k++
				}
				// 判断是否隐藏题库练习入口
				if(!resData.course.exercise_count){
					that.keMenu[5].show = false
				}
				// 设置课程菜单的index
				for(let i in that.keMenu){
					if(that.menuBox == that.keMenu[i].boxId){
						that.menuNum = i
					}
				}
				// 判断进入时的菜单项
				switch(that.menuBox){
					case 'tiku':		// 获取题库练习
						that.get_exercises()
						break;
					case 'zuoye':		// 获取考试
						that.getKaoshiList()
						break;
				}
				// 进入对应的菜单项，触发对应的脚本
				that.menuClick(that.menuNum, that.menuBox)

				document.title = resData.course.title + that.$store.state.titleAfter
				document.documentElement.scrollTop = 0
			}else{
				that.$message.error(data.message);
			}
		})
		.catch(err=> {
			console.log(err);
			that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
		});
		
		
		//获取课件列表
		let attach_url = serverSrc + qianzui + "/course/attach_list/" + this.cInfo.courseId
		this.$ajax.get(attach_url,
			{
				params:{
					page:1
					,page_size:9999
				}
			}
		)
		.then(function(res){
			let resData=res.data
			// console.log(resData);
			if(resData.code==0){
				//添加假数据
				let attList = resData.data.list
				for(let a=0;a<attList.length;a++){
					// if(!attList[a].need_study_time){
					// 	attList[a].need_study_time = 180
					// }
					if(attList[a].attach_watch_record.length == 0){
						attList[a].attach_watch_record[0]={
							attach_id: attList[a].id,
							study_seconds: 0,
							updated_at: "0",
							watch_seconds: 0,
						}
					}
				}

				that.pdfData = resData.data

				let need_finish_number = 0
				resData.data.list.map(item=>{
					if(item.need_study_time) need_finish_number++
				})
				that.pdfData.need_finish_number = need_finish_number
				// console.log(resData.data.list)
				// console.log(resData.data.list[0].attach_watch_record[0])
				// console.log(resData.data.list[0].attach_watch_record[0].study_seconds)
			}else{
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~~');
			}
		})

		//鼠标移出页面或切换页面 暂停播放视频
		window.onblur=function(){ 
			if(!that.leave_stop_play) return false
			if(that.$selfjs.getParamString("courseId")){
				if(that.videoSh && that.hideType === 3){
					if(that.$refs.videoPlayer.player){
						that.$refs.videoPlayer.player.pause()		//暂停视频
					}
					clearInterval(that.global.pageTimer['uViodePlayTimeOut'])
				}
				//暂停PDF的时间计算
				if(that.pdfSh){
					clearInterval(that.global.pageTimer['pdfPlayTimeOut'])
				}
			}
		}
		//鼠标移入移出PDF计时
		$(document).unbind("mouseenter").bind('mouseenter',function(){
			if(that.$selfjs.getParamString("courseId")){
				//继续PDF的时间计算
				// console.log(that.menuBox)
				if(that.menuBox=="ziliao"){
					pdfTimeFn(that)
				}
			}
		}).unbind("mouseleave").bind('mouseleave',function(){
			if(that.$selfjs.getParamString("courseId")){
				//暂停PDF的时间计算
				// console.log(that.menuBox)
				if(that.pdfSh){
					clearInterval(that.global.pageTimer['pdfPlayTimeOut'])
				}
			}
		})
		window.onfocus=function(){
			if(!that.leave_stop_play) return false
			if(that.$selfjs.getParamString("courseId")){
				//继续PDF的时间计算
				// console.log(that.menuBox)
				if(that.menuBox=="ziliao"){
					pdfTimeFn(that)
				}
			}
		}
		// 停止本地流
		if(this.localStream){
			this.removeStream("videoCamera")
		}


		//获取错题数
        this.$ajax.get(serverSrc + qianzui + '/questions/total',{
			params:{
				courseId:this.cInfo.courseId
			}
		})				
		.then(res => {
            this.err_quan_sum = res.data.data[0]
		})

		// 成绩生成计划
		this.my_plan()
	}
    // ,computed: {
	// 	player() {
	// 		return this.$refs.videoPlayer.player
	// 	}
    // }
	,methods:{
		// 课程视频个数
		c_v_num(videos){
			let res = 0
			if(videos.length > 0){
				if(this.unfinished){
					videos.map(video=>{
						if(!this.progressCompute(video, 'bool')) res++
					})
				}else{
					res = videos.length
				}
			}
			return res
		},
		my_plan(){
			this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/user_course_virtual_plans/my_plan",{
				params:{
					course_id: this.cInfo.courseId
				}
			}).then((res)=>{
				let resData = res.data
				if(resData.code == 0){
					if(resData.data){
						// 关闭失焦暂停计时功能
						this.leave_stop_play = false
						// 学生进度作弊类型
						this.cheat_watchType = resData.data.cal_type
						// 学生进度作弊需学习时长
						this.cheat_watchNeedTime = resData.data.cal_value
					}
				}else{
					this.$message.error(resData.message);
				}
			})
		},
		// 课程导航
		keMenu_show(arr){
			let val = false
			if(typeof arr == 'boolean'){
				val = arr
			}else if(arr.indexOf(this.hideType) >= 0){
				val = true
			}
			return val
		},
		// 加载更多样式输出
		jiazaiCompute(type){
			let clas,text
			// if(this.bijiList.length < this.total){
			// 	clas = 'jiazai'
			// 	text = '加载更多'
			// }else if(this.bijiList.length != 0){
			// 	clas = 'jiazai daodi'
			// 	text = '———— 没有更多了 ————'
			// }
			if(type == "class"){
				return clas
			}else if(type == "text"){
				return text
			}
		},
		// 调用权限（打开摄像头功能）
      	getCompetence () {
			let aliRts = rts.AliRTS.createClient()
			/**
			 * isSupport检测是否可用
			 * @param {Object} supportInfo 检测信息
			 * @param {boolean} supportInfo.isReceiveVideo 是否拉视频流
			 * @return {Promise}
			 */
			aliRts.isSupport({
				isReceiveVideo: false
			}).then(re=> {
				// 可用
				let mediaElement = this.$refs.mediaElement
				/**
				 * 获取本地流localStream
				 * @param {Object} config 配置
				 * @param {boolean} config.audio 是否使用音频设备
				 * @param {boolean} config.video 是否使用视频设备
				 * @param {boolean} config.screen 是否使用屏幕捕获
				 * @returns {Promise}
				 */
				rts.AliRTS.createStream({
					audio: true,
					video: true,
					screen: false,
				}).then((localStream) => {
					// 预览推流内容，mediaElement是媒体标签audio或video
					localStream.play(mediaElement);
					// console.log(localStream);
					this.localStream = localStream
					this.camera = 1
				}).catch((err) => {
					// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
					// console.log(err)
					let message = err.message
					if (err.errorCode==10002) {
						message = '找不到摄像头'
					}
					this.$alert(`创建本地流失败，错误码：${err.errorCode}。${message}`, {
						type: 'error',
						confirmButtonText: '确定'
					})
				})
			}).catch(err=> {
				// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
				this.$alert(`错误码：${err.errorCode}。${err.message}`, {
					type: 'error',
					confirmButtonText: '确定'
				})
			})
        	// var _this = this
        	// 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        	// if (navigator.mediaDevices === undefined) {
			// 	navigator.mediaDevices = {}
        	// }
        	// // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        	// // 使用getUserMedia，因为它会覆盖现有的属性。
        	// // 这里，如果缺少getUserMedia属性，就添加它。
        	// if (navigator.mediaDevices.getUserMedia === undefined) {
			// 	// console.log(6);
			// 	navigator.mediaDevices.getUserMedia = function (constraints) {
			// 		// console.log(7);
			// 		// 首先获取现存的getUserMedia(如果存在)
			// 		var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
			// 		// 有些浏览器不支持，会返回错误信息
			// 		// 保持接口一致
			// 		if (!getUserMedia) {
			// 			// console.log(8);
			// 			return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
			// 		}
			// 		// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
			// 		return new Promise(function (resolve, reject) {
			// 			getUserMedia.call(navigator, constraints, resolve, reject)
			// 		})
			// 	}
        	// }
        	// var constraints = { audio: false, video: { width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)' } }
			// // console.log(1);
        	// navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
			// 	// 旧的浏览器可能没有srcObject
			// 	if ('srcObject' in _this.thisVideo) {
			// 		// console.log(3);
			// 		_this.thisVideo.srcObject = stream
			// 	} else {
			// 		// console.log(4);
			// 		// 避免在新的浏览器中使用它，因为它正在被弃用。
			// 		_this.thisVideo.src = window.URL.createObjectURL(stream)
			// 	}
			// 	_this.thisVideo.onloadedmetadata = function (e) {
			// 		// console.log(5);
			// 		_this.camera = 1
			// 		_this.thisVideo.play()
			// 	}
        	// }).catch((err) => {
			// 	console.log(err)
			// 	this.camera = 0
			// 	this.$message.error("未检测到摄像头")
        	// })
      	},
		//考试查看备注
		kaoshibeizhu(data){
			this.beizhuxiangqing=true
			this.beizhuxiangqingtext=data
		},
		//时间文字输出
		timeFn(row, column, cellValue, index){
			let resCon="-",
				timeTxt = row.start_time,
				timeTxt2 = row.end_time
			if(timeTxt != "-"){
				let daytime=timeTxt.split(" ")
					,day=daytime[0]
					,time=daytime[1]
					,dayCon=day.split("-")
				let daytime2=timeTxt2.split(" ")
					,day2=daytime2[0]
					,time2=daytime2[1]
					,dayCon2=day2.split("-")
				resCon=dayCon[0]+"年"+dayCon[1]+"月"+dayCon[2]+"日 "+time+" - "+dayCon2[0]+"年"+dayCon2[1]+"月"+dayCon2[2]+"日 "+time2
			}
			return resCon;
		},
		//考试地点文字输出
		addressFn(row, column, cellValue, index){
			let resCon
			if(row.type == 1){
				resCon='线上考试'
			}else if(row.type == 2){
				resCon='线下考试'
			}
			return resCon;
		},
		//状态文字输出
		statusFn(row, column, cellValue, index){
			// console.log(exam_status);
			let resCon
			if(row.status == 4){
				resCon='已结束'
			}else if(row.status == 3){
				resCon='进行中'
			}else if(row.status == 2){
				resCon='待考'
			}else if(row.status == 1){
				resCon='发布中'
			}
			return resCon;
		},
		tabBtnClas(scope){
			let className=''
			if(scope.row.status!=3){
				className="disable"
			}
			if(scope.row.test_count>=scope.row.number){
				className="disable"
			}
			return 'joinBtn '+className;
		},
		markTxt(row, column, cellValue, index){
			let reCon = row.remark || "-";
			return reCon
		},
		//考试表格操作
		tabCtrlText(status){
			//1未考试（未到考试时间）
			//2待考试（时间内待考试）
			//3待考试（已过时间）
			//4已考试
			let stTxt='考试已结束'
			if(status.status==1){
				stTxt='未到考试时间'
				return stTxt;
			}
			if(status.status==2){
				stTxt='待考'
				return stTxt;
			}
			if(status.status==3&&status.test_count<status.number){
				// stTxt='已完成'
				stTxt='进入考试'
				return stTxt;
			}
			return stTxt;
		},
		tabCtrlText2(data){
			//1未考试（未到考试时间）
			//2待考试（时间内待考试）
			//3待考试（已过时间）
			//4已考试
			let stTxt='进入考试'
			if(data.exam_status==4){
				if(data.correction==7){
					stTxt='未批改'
				}else{
					if(data.adopt==5){
						stTxt='已批改(未通过)'
					}else{
						stTxt='已批改(已通过)'
					}
				}
				// stTxt='已完成'
			}
			return stTxt;
		},
		// 进入考试
		jinrukaoshi(scope){
			let that = this
			//考试状态等于3才能进入考试
			if(scope.row.status == 3){
				this.jinrukaoshidata=scope
				//1需要拍照，-1不需要拍照，0为未设置
				if(scope.row.is_photograph == 1 || scope.row.is_inspection == 1){
					this.camera_open=true		//打开验证摄像头功能弹窗
					setTimeout(function(){
						that.getCompetence()		// 调用权限（打开摄像头功能）
					},100)
				}else{
					this.join_kaoshi(this.jinrukaoshidata)
				}
			}
		},
		//跳转到考试页
		join_kaoshi(scope, index, rows) {
			// return false
			//考试状态等于3 且 提交次数 小于 限制次数
			if(scope.row.status == 3 && (scope.row.test_count < scope.row.number) ){
				this.this_test_id = scope.row.test_id
				//打开进入考试页开关
				let global_join_kaoshi = this.global.join_kaoshi
				global_join_kaoshi.switch = true
				// 判断是否需要拍摄照片，1：需要，-1：不需要，0为未设置
				if(scope.row.is_photograph == 1){
					global_join_kaoshi.is_photograph = true
					global_join_kaoshi.photo_num_min = scope.row.photo_num_min
					global_join_kaoshi.photo_num_max = scope.row.photo_num_max
					global_join_kaoshi.photograph_interval = scope.row.photograph_interval
				}else if(scope.row.is_photograph == -1){
					global_join_kaoshi.is_photograph = false
				}
				if(global_join_kaoshi.is_photograph && this.camera != 1){
					this.$message.error("未检测到摄像头")
					return false
				}
				// 判断是否需要巡考，1：需要，-1：不需要，0为未设置
				if(scope.row.is_inspection == 1){
					global_join_kaoshi.is_inspection = true
				}else if(scope.row.is_inspection == -1){
					global_join_kaoshi.is_inspection = false
				}
				if(global_join_kaoshi.is_inspection && this.camera != 1){
					this.$message.error("未检测到摄像头!")
					return false
				}

				// 移除本地流
				this.removeStream("videoCamera")
				if (scope.row.is_face_verification==2) {
					if (this.certified) {
						this.tab_bol = true
					}else{
						this.$message.error("请先完成实名认证！")
					}
					
				}else{
					//跳转到考试页
					this.$router.push({
						path: '/web/courseInfo/test/',
						name: 'test',
						query: {courseId: this.cInfo.courseId, test_id: scope.row.test_id},
						params: ''
					})	
				}
				
			}
		},
		//跳转到考试结果页
		join_kaoshi2(scope, index, rows) {
			this.$router.push({
				path: '/web/courseInfo/jieguo/',
				name: 'jieguo',
				query: {log_id: scope.row.log_id, test_id: scope.row.test_id,courseId: this.cInfo.courseId},
				params: ''
			})

		},
		//秒转换成日时分秒
		secondsFormat(s,option) { 
			let defa_option = {
				format :"DD天H时M分S秒"
			}
			option = Object.assign({},defa_option,option)
			// if(s){
				var day
				if(option.format){
					day = option.format.indexOf("DD") > -1 ? Math.floor( s/ (24*3600) ) : 0 // Math.floor()向下取整 
				}
				// var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整 
				var hour = Math.floor( (s - day*24*3600) / 3600); 
				var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 ); 
				var second = s - day*24*3600 - hour*3600 - minute*60; 
				if(option){
					if(option.format){
						let resCon = option.format
						resCon = resCon.replace(/DD/,day)
						resCon = resCon.replace(/H/,hour)
						resCon = resCon.replace(/M/,minute)
						resCon = resCon.replace(/S/,second)
						return resCon
					}
				}
				return day + "天"  + hour + "时" + minute + "分" + second + "秒"; 
			// }else{
			// 	return 0 + "天"  + 0 + "时" + 0 + "分" + 0 + "秒"; 
			// }
		},
		//课程完成进度百分比计算
		progressCompute(item, type){
			// return 30
			let start, res = 0
				,true_color = "#92ecbf"
			if(item.user_video_record && item.user_video_record.length>0){
				start = item.user_video_record[0].study_seconds
			}else if(item.attach_watch_record && item.attach_watch_record.length>0){
				start = item.attach_watch_record[0].study_seconds
			}
			let end = item.need_study_time

			if(type == 'tiku'){
				start = item.finish
				end = item.count
			}
				let progre_com = parseInt((start/end)*100)
				res = start ? ( progre_com > 100 ? 100 : progre_com ) : 0
				
				// 视频记录完成
				let v_com_bool = item.student_learn_progress && item.student_learn_progress.length > 0 && item.student_learn_progress[0].is_finish == 1
				if(item.duration && v_com_bool){
					if(type == "bool"){
						res = true
					}else if(type == "color"){
						res = true_color
					}
					return res
				}
				// 值返回
				if(res >= 100){
					if(type == "bool"){
						res = true
					}else if(type == "color"){
						res = true_color
					}
				}else{
					if(type == "bool"){
						res =  this.hideType === 3 ? false : true
					}else if(type == "color"){
						res = "#faa757"
					}
				}
			// if(type != "color" && type != "bool"){
			// 	console.log(res)
			// }
			return res
		},
		//课程栏目切换
		async menuClick(i,boxId){
			// if()
			
			this.menuNum=i
			this.menuBox=boxId
			//
			// $("html,body").scrollTop(100)
			if(this.videoSh){
				this.$refs.videoPlayer.player.pause()
				
				clearInterval(this.global.pageTimer['uViodePlayTimeOut'])
			}
			if(boxId == "shipin"){
				
				//直接加载第一个视频
				if(this.courseData.chapters.length>0 && !this.courseData.last_watch.video){
					let chapter_id = Object.keys(this.courseData.videos)[0],
						chapter = this.courseData.chapters.find(item=> item.id == chapter_id)
					if(this.vidArrNum == 0){
						this.getVideo(this.courseData.videos[chapter_id][0], 0, chapter)
					}
				}
			}
			if(boxId == "biji"&&this.bijiOne){
				this.bijishuju()
				this.bijiOne=false
			}
			// taolun
			if(boxId == "taolun"&&this.taolunOne){
				// this.bijishuju()
				this.taolunjiazai=true
				// 讨论列表 所有
				await this.taolunsum()
				// 讨论列表 我的
				await this.mytaolun()
				// 我回复的
				await this.huifuda()
				this.taolunjiazai=false
				this.taolunOne=false
			}
			if(this.pdfSh){
				clearInterval(this.global.pageTimer['pdfPlayTimeOut'])
				if(boxId=="ziliao"){
					pdfTimeFn(this)		//记录标题
				}
			}
			// 点击题库练习
			if(boxId == "tiku"){
				// 获取题库练习列表
				this.get_exercises()
			}
			// 点击题库练习
			if(boxId == "zuoye"){
				// 获取题库练习列表
				this.getKaoshiList()
			}
		}
		//视频列表切换
		,spListSw(i, event){
			this.spListSh=i;
		}
		//视频章节标题点击滚动到对应位置
		,moveZhang(event){
			var el=event.currentTarget;
			// clearTimeout(ofT);
			// let ofT=setTimeout(function(){
			// 	$("html,body").animate({
			// 		scrollTop:$(el).parent().offset().top
			// 	})
			// },100)
			// clearTimeout(ofT);
			// let ofT=setTimeout(function(){
			// 	document.documentElement.scrollTop = el.offsetTop
			// },250)
		}
		//获取视频信息
		,getVideo(video, arrnum, chapters){
			var that=this
				,token=this.$cookies.get("token")
				,serverSrc=that.global.serverSrc
				,qianzui=that.global.qianzui

			// 滚动到播放区域
			let bodySroll = $("html,body").scrollTop(),
				kemenuSroll = $(".ke_menu").offset().top-15
			if(bodySroll > kemenuSroll){
				$("html,body").animate({
					scrollTop:$(".ke_menu").offset().top-15
				})
			}
			if(this.playVid!=video.id){
				this.vloading = true;
			}else{
				return true
			}
			this.vidArrNum = arrnum		//章节下第几个视频

			//设置播放内容的章节和标题
			this.v_zhang_tit=chapters.title
			this.v_jie_tit=video.title
			//计算下一节的章节和标题
			let next_zhang, next_zhang_id = 0, next_jie, next_video_obj, next_chapArrNum = 0, next_videoArrNum = 0
			if(chapters.id){
				let chap_index = this.chaptersIdArr.indexOf(chapters.id.toString())
				if(this.course.videos[chapters.id][arrnum+1]){		//判断该章节是否有下一个视频
					next_video_obj = this.course.videos[chapters.id][arrnum+1]

					next_chapArrNum = chap_index
					next_videoArrNum = arrnum+1
					next_zhang_id = chapters.id
					next_zhang = chapters.title
					next_jie = next_video_obj.title
				}else{
					let next_chap_id = this.chaptersIdArr[chap_index+1]
					if(next_chap_id){			//判断是否有下一章
						next_video_obj = this.course.videos[next_chap_id][0]
						
						next_chapArrNum = chap_index+1
						next_videoArrNum = 0
						next_zhang_id = next_chap_id
						next_zhang = this.course.chapters[chap_index+1].title
						next_jie = next_video_obj.title
					}else{
						next_zhang = ''
						next_jie = ''
					}
				}
			}
			this.next_video = {
				zhang:{
					title:next_zhang,
					num:next_chapArrNum,
					id:next_zhang_id,
				},
				jie:{
					title:next_jie,
					num:next_videoArrNum,
				},
			}

			//记录当前视频ID
			this.playCid=chapters.id
			this.playVid=video.id
			
			//获取视频信息
			let url = serverSrc + qianzui + "/video/" + video.id + "/playinfo?course_id="+this.cInfo.courseId + "&id="+video.id
			this.$ajax.get(url)
			.then(res=>{
				let resData=res.data
				if(resData.code==0){
					// console.log(resData.data.urls);
					if(resData.data.urls.length>0){
						clearInterval(that.global.pageTimer['uViodePlayTimeOut'])
						that.videoSh=true
						that.thisPlayVideoSt = that.progressCompute(video, 'bool');
						that.cheat_drag = that.cheat_drag_status == 1 && that.cheat_watchType != 0			// 白名单用户才能初始化作弊开关
						// 初始化记录学生观看时长（清零重算）
						this.user_video_record_time = 0
						that.playerOptions.sources[0].type="video/"+resData.data.urls[0].format
						that.playerOptions.sources[0].src = resData.data.urls[0].url
						//必须有last_watch.watch_seconds参数大于0，且(观看记录+10秒)大于视频总时长
						let watch_seconds = resData.data.last_watch.watch_seconds		// 结束观看的时长
							,duration = parseInt(resData.data.urls[0].duration)			// 视频总时长
						// 如果结束时长+5秒也大于等于视频总时长则清空记录时长，否则直接把视频进度调到结束观看的时长
						if(watch_seconds+5 >= duration){
							that.thisVideoDuration = 0
						}else{
							that.thisVideoDuration = watch_seconds
						}
						// 设置分辨率选择项
						this.resolution_options = resData.data.urls.map(v=>{
							return Object.assign(v, {
								value: v.url,
								label: v.name,
							})
						})
						// 设置当前分辨率
						this.resolution_val = resData.data.urls[0].url
						// 学习平台针对成考湛科(47)/东城(46)的学生，50%开启随机完成的假BUG
						// that.fake_bug = false
						// if(that.random_auto_complete && (that.school_id == 47 || that.school_id == 46) && Math.floor(Math.random()*100) >= 50){
						// 	that.fake_bug = true
							
						// 	// 生成随机完成数
						// 	let currentHour = that.$moment().hour()
						// 	// 生成需要达到的假完成进度
						// 	// 早上8点-晚上8点期间，完成进度条百分比随机区间：50%-90%
						// 	// 晚上8点-次日8点期间，完成进度条百分比随机区间：20%-45%
						// 	that.fake_finish_progre = currentHour >= 8 && currentHour < 20 ? that.random_progre(50, 90) : that.random_progre(20, 45)

						// 	console.log('fake:'+that.fake_bug)
						// }
					}else{
						that.$message.error("无视频信息");
					}
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~~~');
				}
			})
			.catch((err) => {
				console.log(err);
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~~~~');
			});
		}
		//获取PDF路径
		,getPdf(item, event, i){
			if (item.extension!='pdf') {
				return false
			}
			 var that=this
				,el=event.currentTarget
				
				this.pdfload = false
				if(item.path == ""){
					that.pdfsrc = that.global.serverSrc + that.global.qianzui + "/other/download/" + item.id;		//PDF框路径
				}else{
					that.pdfsrc =  that.global.oss_link + item.path;		//PDF框路径
				}
				that.pdfSh=true			//显示PDF框
				that.pdftit = el.getElementsByTagName('p')[0].innerHTML;			//PDF框标题
				that.pdfPlay = {
					id:item.id,
					num:i,
				}
				
				pdfTimeFn(that)		//记录标题

				//滚动到PDF区域
				let bodySroll = $("html,body").scrollTop(),
					kemenuSroll = $(".ke_menu").offset().top-15
				if(bodySroll > kemenuSroll){
					$("html,body").animate({
						scrollTop:$(".ke_menu").offset().top-15
					})
				}
		},
		//播放下一节
		nextVideo(){
			let chapid = this.next_video.zhang.id
			if(chapid == 0){
				return false
			}
			let arrnum = this.next_video.jie.num,
				video = this.course.videos[chapid][arrnum],
				chapters = this.course.chapters[this.next_video.zhang.num]
			
			this.spListSh = this.next_video.zhang.num
			this.getVideo(video, arrnum, chapters)
		},
		// 播放回调
		onPlayerPlay(player) {
			// console.log(player);
			
			var that=this

			// 封面数秒后关闭（最大100秒）
			if(this.pay_start_ad == 1) $(".v_thumb, .v_courseImgContent").addClass(`fade-out${this.pay_start_ad_time}`)

			//用户实际观看时长
			clearInterval(that.global.pageTimer['uViodePlayTimeOut'])
			that.global.pageTimer['uViodePlayTimeOut']=setInterval(() => {
				// console.log('videoTime'+that.uViodePlayPostTime);
				that.course.course.video_study_time++		//记录学习时长
				
				//实时计算课程圆形进度条
				let video_data = that.course.videos[that.playCid][that.vidArrNum],		//当前播放视频的数据
					user_video_record = video_data.user_video_record,					//播放记录
					learn_progress = video_data.student_learn_progress,					//进度完成情况
					need_time = video_data.need_study_time								//视频需观看时长
				
				// 如果作弊观看类型不等于0，则把作弊时长替换原需观看时长
				// 如果cheat_watchType == 1，用户看视频到达cheat_watchNeedTime秒时，触发完成条件
				// 如果cheat_watchType == 2，用户看视频到达cheat_watchNeedTime进度时(如 视频时长duration=2917，cheat_watchNeedTime=10时，触发秒数= duration*(cheat_watchNeedTime/100) 取下限)，触发完成条件
				switch (this.cheat_watchType){
					case 1:
						need_time = this.cheat_watchNeedTime
						break;
					case 2:
						need_time = video_data.duration * ( this.cheat_watchNeedTime / 100 )
						break;
				}

				if(user_video_record.length > 0){
					//记录视频进度
					user_video_record[0].study_seconds++
					// 记录学生观看时长，达到触发接口秒数后 或 观看新的视频时，清零重算
					this.user_video_record_time++
					// 学习平台针对成考湛科/东城的学生，设置随机完成(假BUG)
					// let currentHour = this.$moment().hour()
					// 获取当前播放器进度条（单位：%）
					// let learn_progre = parseInt(user_video_record[0].study_seconds / need_time * 100)

					// 早上8点-晚上8点期间
					// const daytime_h = currentHour >= 8 && currentHour < 20;
					// 已完成进度在50~90之间，且 已完成进度 与 区间随机进度 相等，触发直接完成
					// const daytime = daytime_h && learn_progre == this.fake_finish_progre

					// 晚上8点-次日8点期间
					// const night_h = currentHour >= 20 || currentHour < 8;
					// 已完成进度在20~45之间，且 已完成进度 与 区间随机进度 相等，触发直接完成
					// const night = night_h && learn_progre == this.fake_finish_progre

					// if((daytime || night) && this.fake_bug && this.cheat_watchType == 0 && this.random_auto_complete){
					// 	// 视频进度记录（秒）
					// 	this.ViodePlayPostTime = video_data.need_study_time
					// 	// 学生学习的时间（秒）
					// 	user_video_record[0].study_seconds = video_data.need_study_time
					// 	// 修改播放器进度条到需学习的时长
					// 	this.thisVideoDuration = video_data.need_study_time
					// 	this.$refs.videoPlayer.player.currentTime(this.thisVideoDuration)
					// 	// 此次（接口）学习的时长（秒）
					// 	this.uViodePlayTime = video_data.need_study_time

					// 	console.log('fakeRun:'+this.fake_bug)
					// }
				}
				// 作弊开关判断
				if(this.cheat_drag){
					this.thisPlayVideoSt = true				// 打开视频的拖拽进度条开关
					this.cheat_drag = false					// 拖拽作弊开关
					recordFn(this, {
						thisTime: this.ViodePlayPostTime,			// 视频进度(秒)
						postTime: this.ViodePlayPostTime,				// 学习记录间隔(秒)
						st: 4,
						success: res=>{
							// this.thisPlayVideoSt = false
							user_video_record[0].study_seconds = user_video_record[0].study_seconds + this.ViodePlayPostTime	// 记录视频进度
							this.course.course.video_study_time = this.course.course.video_study_time + this.ViodePlayPostTime	// 记录学习时长
						},
						finish_success: res=>{
							//弹窗提示视频已经学习完
							this.$refs.videoPlayer.player.pause()					// 暂停视频
							// that.$alert('本小节学习已完成', '', {
							// 	confirmButtonText: '确定'
							// });
						}
					})
					// 如果视频学习时长大于3分钟打开拖拽开关
				}else if(user_video_record[0].study_seconds > this.cheat_sw_time && this.cheat_drag_status == 1 && this.cheat_watchType != 0){
					this.thisPlayVideoSt = true				// 打开视频的拖拽进度条开关
				}
				//如果视频已学习到对应的时间，则判断该视频已学习完成及提醒
				if(user_video_record[0].study_seconds >= need_time && (learn_progress.length == 0 || learn_progress[0].is_finish == 0) ){
					
					// 开启学生进度作弊时
					// 如果作弊观看类型不等于0，则把作弊时长替换原需观看时长
					// 如果cheat_watchType == 1，用户看视频到达cheat_watchNeedTime秒时，触发完成条件
					// 如果cheat_watchType == 2，用户看视频到达cheat_watchNeedTime进度时(如 视频时长duration=2917，cheat_watchNeedTime=10时，触发秒数= duration*(cheat_watchNeedTime/100) 取下限)，触发完成条件
					if(that.cheat_watchType != 0){
						// 根据公式生成随机学习数
						let random_study = parseInt(Math.random() * (video_data.duration - video_data.need_study_time) + video_data.need_study_time)
						recordFn(this, {
							thisTime: random_study,
							postTime: random_study,
							st: 3,
							success: res=>{
								// 记录视频进度
								// user_video_record[0].study_seconds = user_video_record[0].study_seconds + random_study
								// 记录学习时长
								// this.course.course.video_study_time = this.course.course.video_study_time + random_study
							}
						})
					}else{
						recordFn(this, {
							thisTime: this.uViodePlayTime,
							postTime: this.uViodePlayTime,
							st: 2,
							success: res=>{
								// 触发假BUG后，恢复正常的学习时长间隔
								this.uViodePlayTime = this.$store.state.app_config.study.record.video_interval
							}
						})
					}
					return true
				}
				recordFn(this, {
					thisTime: this.user_video_record_time,
					postTime: this.uViodePlayTime,
					st: 1,
				})
			},1000)
			//console.log('player play!', player)
		},
		// 正在拖动
		videoSeeking($event) {
			// console.log($event);
			// this.isSeeking = true
		},
		// 拖动结束
		videoSeeked($event) {
			// console.log($event);
			let video_data = this.course.videos[this.playCid][this.vidArrNum],		//当前播放视频的数据
				user_video_record = video_data.user_video_record					//播放记录
				
			// 白名单用户，有学习时长要求的才能打开作弊开关 且 视频学习时长大于3分钟打开拖拽开关
			if(this.cheat_watchType != 0 && this.hideType == 3 && this.cheat_drag_status == 1 && user_video_record[0].study_seconds > this.cheat_sw_time){
				this.cheat_drag = true							// 拖拽作弊开关
			}
			// this.isSeeking = false
		},
		// 暂停回调
		onPlayerPause(player) {
			// console.log(uViodePlayTime);
			var that=this
			clearInterval(that.global.pageTimer['uViodePlayTimeOut'])
			//console.log('player pause!', player)
		},
		// 视频播完回调
		onPlayerEnded($event) {
			// console.log($event)
		},
		// DOM元素上的readyState更改导致播放停止
		onPlayerWaiting($event) {
			// console.log($event)
		},
		// 已开始播放回调
		onPlayerPlaying($event) {
			// console.log($event)
		},
		// 当播放器在当前播放位置下载数据时触发
		onPlayerLoadeddata($event) {
			// console.log($event)
		},
		// 当前播放位置发生变化时触发。
		onPlayerTimeupdate(player) {
			var that = this
			that.ViodePlayPostTime = parseInt(player.cache_.currentTime);

			let is_finish_video = this.course.score.videos.is_finish_video
			if(is_finish_video == 1 && this.course_video_complete_restrict_pay){
				this.$alert('当前课程视频已完成学习，视频可得分数已全部取得！', '', {
					confirmButtonText: '确定'
				});
				this.$refs.videoPlayer.player.pause()
			}
			// postNum++
			// if(postNum==4){
			// 	// console.log(parseInt(player.cache_.currentTime))
			// 	recordFn(that.ViodePlayPostTime, that.ViodePlayTime, that, '')
			// 	postNum=0;
			// }
			//this.gklog = player.cache_.currentTime
		// console.log(' onPlayerTimeupdate!', this.gklog)
		},
		//媒体的readyState为HAVE_FUTURE_DATA或更高
		onPlayerCanplay(player) {
			let that = this
			this.vloading=false;
			setTimeout(()=>{
				let videoPlayer = $(this.$refs.videoPlayer.$el)
				if(videoPlayer.find(".schoolLogo").length == 0){
					let course = this.courseData.course
						,vjs_tech = videoPlayer.find(".vjs-tech")
						,vjs_js = videoPlayer.find(".video-js")
					// 添加课程封面
					if(this.pay_start_ad == 1){
						if(course.thumb && course.thumb != '-' && course.thumb != 1){
							vjs_tech.after(`<div class="v_thumb"><img src="${this.global.oss_website+this.courseData.course.thumb}"/></div>`)
						}else{
							vjs_tech.after(`<div class="v_courseImgContent">${this.courseData.course.title}</div>`)
						}
					}
					// 添加网校LOGO
					vjs_js.append(`<div class="schoolLogo"><img src="${this.$store.state.school_logo}"/></div>`)
				}
			},100)
			// console.log(player);
			// console.log('player Canplay!', player)
		},
		//媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
		onPlayerCanplaythrough(player) {
			// console.log(player);
			// console.log('player Canplaythrough!', player)
		},
		// 播放状态改变回调
		playerStateChanged(playerCurrentState) {
			// console.log(playerCurrentState);
			// playerCurrentState: ended=播放结束
			if(playerCurrentState.ended){
				// console.log(playerCurrentState);
				recordFn(this, {
					thisTime: 1,
					postTime: 1,
					type: 1,
					st: 'playerStateChanged',
				})
			}
			//console.log('player current update state', playerCurrentState)
		},
		//将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
		playerReadied(player,playtimes) {
			player.currentTime(this.thisVideoDuration)
			// console.log(player);
		// player.currentTime(playtimes)
		// console.log('example player 1 readied', player);
		}
		//屏蔽播放器右击行为
		,menuPlayer(){
			return false;
		},
		// 讨论切换
		taoluntab(e){
			this.allDiscdata.list_discuss.forEach((e)=>{e.pinglun=false})
			this.myDiscdata.list.forEach((e)=>{e.pinglun=false})
			// console.log(e);
		},
		// input输入框大小
		inputSize(e){
			// console.log(e);
			this.inputDaxiao = "width:"+(e.length*16)+"px;"
			if(e.length>0){this.fasong="primary"}else{this.fasong=""}
			// console.log(this.inputDaxiao);
		},
		// 我的讨论
		mytaolun(){
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			let lat = query.courseId;
			this.$ajax.get(serverSrc + qianzui + "/discuss/list_discuss_my",{params:{page:1,page_size:999,course_id:lat}})
			.then(res=>{
			this.myDiscdata=res.data.data
			for(var i = 0;i<this.myDiscdata.list.length;i++){
				this.$set(this.myDiscdata.list[i],"pinglun",false)
				}
			})
		},
		//所有讨论
		taolunsum(){
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			let lat = query.courseId;
			this.$ajax.get(serverSrc + qianzui + "/discuss/list_discuss_all",{params:{page:1,page_size:999,course_id:lat}})
			.then((res)=>{
			this.allDiscdata = res.data.data
			// console.log(this.allDiscdata)
			for(var i = 0;i<this.allDiscdata.list_discuss.length;i++){
				this.$set(this.allDiscdata.list_discuss[i],"pinglun",false)
			}
			// console.log(this.allDiscdata);
			// console.log(this.allDiscdata.list_discuss.pinglun);
			})
		},
		// 回复数据
		huifuda(){
			var token = this.$cookies.get("token"),
			serverSrc = this.global.serverSrc,
			qianzui = this.global.qianzui;
			let query=this.$route.query;
			let lat = query.courseId;
			this.$ajax.get(serverSrc + qianzui + "/discuss/my_reply_list",{params:{page:1,page_size:100,course_id:lat}})
			.then((res)=>{
			this.huifudata = res.data.data
			this.data_total = this.huifudata.total
			// console.log(this.huifudata);
		})
		},
		// 讨论弹出
		taoluntangchu(){
			this.taolunfasong.title=''
			this.taolunfasong.content=''
			this.taolundialogVisible=true
		},
		//讨论保存
		fabiaitaolun(){
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			// 新增讨论 Too few arguments to function Illuminate\Database\…sController.php on line 52 and exactly 1 expected
			let taolun_url = serverSrc + qianzui + "/discuss/add_discuss"
			let token=this.$cookies.get("token")
			const loading = this.$loading({
          		lock: true,
          		text: 'Loading',
          		spinner: 'el-icon-loading',
          		background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(taolun_url,this.$qs.stringify(this.taolunfasong))
			.then((res)=>{
				if(res.data.code!==0){
					this.$message({
          				showClose: true,
          				message: res.data.message,
          				type: 'error'
        			})
				}else{
					this.taolunfasong.title=''
					this.taolunfasong.content=''
					this.taolundialogVisible=false
					let query=this.$route.query;
					let lat = query.courseId;
					this.taolunsum()
					// 讨论列表 我的
					this.mytaolun()
					this.$message({
          				showClose: true,
          				message: "发表成功",
          				type: 'success'
        			})
				}
				loading.close();
			})
			if((this.myDiscdata.list.length*this.courseData.score.discuss.discuss_single_score)>=10){
				// console.log(this.courseData.score.current_total);
				
				this.courseData.score.discuss.discuss_score=10
			}else{
				this.courseData.score.discuss.discuss_score=this.myDiscdata.list.length*this.courseData.score.discuss.discuss_single_score+2
			}
			// if()
			let current_total=this.courseData.score.total_score.current_total
			if(this.courseData.score.discuss.discuss_score==this.courseData.score.discuss.discuss_total){
				if(this.fenshu){
					this.courseData.score.total_score.current_total=(this.courseData.score.total_score.current_total-0)+(this.courseData.score.discuss.discuss_single_score-0)
					this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
					if(this.courseData.score.total_score.current_total > 100){
						this.courseData.score.total_score.current_total = 100
					}
					this.fenshu=false
				}
			}else{
				this.courseData.score.total_score.current_total=(this.courseData.score.total_score.current_total-0)+(this.courseData.score.discuss.discuss_single_score-0)
				this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
				if(this.courseData.score.total_score.current_total > 100){
					this.courseData.score.total_score.current_total = 100
				}
			}
		},
		// 获取回复
		huifuhuoqu(id){
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			let token=this.$cookies.get("token")
			this.$ajax.get(serverSrc + qianzui +"/discuss/discuss_detail",{params:{id:id}})
			.then((res)=>{
				this.replydata = res.data.data
				// console.log(this.replydata);
				this.gengduodata2=JSON.parse(JSON.stringify(this.replydata))
				this.gengduodata2.reply=this.gengduodata2.reply.slice(0,3)
				// console.log(this.gengduodata2.reply);
				// console.log(this.replydata.reply);
			})
		},
		// 获取考试
		getKaoshiList(){
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			let lat = query.courseId;
			this.$ajax.get(serverSrc + qianzui +"/exam/test_list",{params:{course_id:lat}})
			.then((res)=>{
				// let resData = res.data
				this.kaoshiList = res.data.data

				// if(resData.code == 0 && resData.data.title){
				// 	this.kaoshiList.push(resData.data)
				// 	// this.kaoshiList.push(resData.data)
				// }
			})
		},
		// 笔记弹出
		bijitangchu(){
			this.bijiwancheng=true
			this.bijicanshu.title=''
			this.bijicanshu.content=''
			this.bijidialogVisible=true
			
		},
		//点击展开
		zhankai(i,id){
			this.gengduodata2.reply=[]
			this.replydata.reply=[]
			this.chavule="查看更多"
			this.chakang=true
			// this.pinglun=!this.pinglun
			// console.log(i);
			this.myDiscdata.list.forEach((e,index)=>{
				if(i===index){
					// console.log(index);
				}else{
					e.pinglun=false
				}
			})
			this.myDiscdata.list[i].pinglun=!this.myDiscdata.list[i].pinglun
			this.huifuhuoqu(id)
		},
		zhankai2(i,id,name){
			this.themedata.reply=[]
			this.gengduodata.reply=[]
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			if(name){
				this.allDiscdata.list_discuss.forEach(e=>{
					e.pinglun=false
				})
				// this.allDiscdata.list_discuss[i].pinglun=true
				this.$nextTick(function(){
					document.documentElement.scrollTop = this.$refs['gaodu'+id][0].offsetTop
					this.allDiscdata.list_discuss.forEach((e,index)=>{
						if(i===index){
							// console.log(index);
							e.pinglun=true
						}else{
							e.pinglun=false
						}
					})
					this.allDiscdata.list_discuss[i].pinglun=true
					let token=this.$cookies.get("token")
					// console.log(name);
					// console.log(id);
					this.$ajax.get(serverSrc + qianzui +"/discuss/discuss_detail",{params:{id:id}})
					.then((res)=>{
						// this.$set(themedata)
						this.themedata = res.data.data
						this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
						// console.log(this.gengduodata.reply);
						this.cha=this.gengduodata.reply.length
						// this.gengduodata.reply=this.gengduodata.reply.slice(0,3)
					})
				})
			}else{
			// console.log(this.$refs['gaodu'+id][0].offsetHeight);
			this.chavule="查看更多"
			this.chakang=true
			// console.log(i);
			// console.log(this.allDiscdata.list_discuss[i].pinglun);
			// console.log(id);
			this.allDiscdata.list_discuss.forEach((e,index)=>{
				if(i===index){
					// console.log(index);
				}else{
					e.pinglun=false
				}
				
				
			})
			this.allDiscdata.list_discuss[i].pinglun=!this.allDiscdata.list_discuss[i].pinglun
			let token=this.$cookies.get("token")
			// console.log(name);
			// console.log(id);
			this.$ajax.get(serverSrc + qianzui +"/discuss/discuss_detail",{params:{id:id}})
			.then((res)=>{
				// this.$set(themedata)
				this.themedata = res.data.data
				this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
				this.gengduodata.reply=this.gengduodata.reply.slice(0,3)
			})
			}
		},
		// 文本显示隐藏
		expandeClick(i) {
			// bijidata.list[i]
			if(this.bijidata.list[i].zhanshi=='展开全文'){
				this.bijidata.list[i].zhanshi='收起全文',
				this.bijidata.list[i].pneirong=false
			}else{
				this.bijidata.list[i].zhanshi='展开全文',
				this.bijidata.list[i].pneirong=true
			}
        },
		// 发送回复
		async fasonghuifu(i,id,name){
			let input = this.inputsiz.replace(/^\s*|\s*$/g,"")
			if(input!=''){
				this.allDiscdata.list_discuss.forEach(e=>{
				if(e.id==id){
					e.reply_count++
				}
				})
			}
			
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			// this.inputsiz = ""
			let con = this.inputsiz
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			let lat = query.courseId;			
			this.$ajax.post(serverSrc + qianzui + "/discuss/add_reply",this.$qs.stringify({discuss_id: id,content:con,course_id:lat}))
			.then((res)=>{
				// console.log(res);
			})
			let data = await this.$ajax.get(serverSrc + qianzui +"/discuss/discuss_detail",{params:{id:id}})
			 this.themedata  = data.data.data
			 this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
			
			
			this.$ajax.get(serverSrc + qianzui +"/discuss/discuss_detail",{params:{id:id}})
			.then((res)=>{
				// this.$set(themedata)
				this.themedata = res.data.data
				this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
				// this.chavule="查看更多"
				// this.chakang=true
				if(!this.chakang){
					this.cha=this.gengduodata.reply.length
				}else{
					this.cha=3
				}
			})
			this.inputsiz=""
			this.inputDaxiao="width:200px"
			this.fasong=""
			this.huifuda()
			this.mytaolun()
		},
		// 查看更多
		chakangduo(){
			if(this.chakang){
				this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
				this.chakang=false
				this.chavule="收起详情"
				this.cha=this.gengduodata.reply.length
			}else{
				this.gengduodata=JSON.parse(JSON.stringify(this.themedata))
				this.cha=3
				this.chavule="查看更多"
				this.chakang=true
			}
			
		},
		chakangduo2(){
			if(this.chakang){
				this.gengduodata2=JSON.parse(JSON.stringify(this.replydata))
				this.chakang=false
				this.chavule="收起详情"
			}else{
				this.gengduodata2=JSON.parse(JSON.stringify(this.replydata))
				this.gengduodata2.reply=this.gengduodata2.reply.slice(0,3)
				this.chavule="查看更多"
				this.chakang=true
			}
		},
		// 点击回复跳转
		huifutiaozhuan(id){
			this.chavule="收起详情"
			this.chakang=false
			this.radio1 = "所有讨论"
			let i = this.allDiscdata.list_discuss.findIndex((n)=>n.id==id);
			this.zhankai2(i,id,true)
		},
		// 笔记数据
		bijishuju(){
			// 笔记数据 1
			this.bijijiazai=true
			var token = this.$cookies.get("token"),
			serverSrc = this.global.serverSrc,
			qianzui = this.global.qianzui;
			let query=this.$route.query;
			let lat = query.courseId;	
			this.$ajax.get(serverSrc + qianzui + "/notes/list_notes",{params:{page:this.biji_now_page,page_size:999,course_id:lat}})
			.then((res)=>{
				this.bijijiazai=false
				this.bijidata = res.data.data
				this.bijidata.list.forEach(e => {
					this.$set(e,"pneirong",false)
					if(e.content.length>530){
						this.$set(e,"zhanshi",'展开全文')
						e.pneirong=true
						this.$set(e,"zhankai",true)
					}else{
						this.$set(e,"zhankai",false)
					}
				});
			})
			.catch((err)=>{
				console.log(err);
				this.bijijiazai=false
			  	// console.log(err)aaaa
				this.$message.error('异常');
			})
		},
		// 新增笔记
		addBiji(panduan){
			var token = this.$cookies.get("token"),
				serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui;
			let query=this.$route.query;
			let lat = query.courseId;
			if(panduan){
				var title = this.bijicanshu.title.replace(/^\s*|\s*$/g,"")
				var content = this.bijicanshu.content.replace(/^\s*|\s*$/g,"")
				if(title==''||content==''){
					this.$message({
						showClose: true,
						message: "请输入标题或内容",
						type: 'error'
					})
				}else{
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$ajax.post(serverSrc + qianzui + "/notes/add_notes",
						this.$qs.stringify({
							title: this.bijicanshu.title,
							content:this.bijicanshu.content,
							course_id:lat
						})
					)
					.then((res)=>{
						if(res.data.code!==0){
							this.$message({
								showClose: true,
								message: res.data.message,
								type: 'error'
							})
						}else{
							let query=this.$route.query;
							let lat = query.courseId;
							this.bijishuju()
							this.$message({
								showClose: true,
								message: "记录成功",
								type: 'success'
							})
							this.bijidialogVisible=false
						}
						if(this.courseData.score.notes.notes_score>=this.courseData.score.notes.notes_total){
							// this.courseData.score.total_score.current_total=(this.courseData.score.total_score.current_total-0)+(this.courseData.score.notes.notes_single_score-0)
							// this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
							// this.fenshu2=false
						}else{
							this.courseData.score.total_score.current_total=(this.courseData.score.total_score.current_total-0)+(this.courseData.score.notes.notes_single_score-0)
							this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
							if(this.courseData.score.total_score.current_total > 100){
								this.courseData.score.total_score.current_total = 100
							}
						}
						if((this.bijidata.list.length*this.courseData.score.notes.notes_single_score)>=10){
							this.courseData.score.notes.notes_score=10
						}else{
							this.courseData.score.notes.notes_score=this.bijidata.list.length*this.courseData.score.notes.notes_single_score+2
						}
						loading.close();
					})
				}
				
					
			}else{
				// this.bijicanshu.title=this.bijicanshu.title.replace(/^\s*|\s*$/g,"")
				var title = this.bijicanshu.title.replace(/^\s*|\s*$/g,"")
				var content = this.bijicanshu.content.replace(/^\s*|\s*$/g,"")
				// this.bijicanshu.content=this.bijicanshu.content.replace(/^\s*|\s*$/g,"")
				if(title==''||content==''){
					this.$message({
							showClose: true,
							message: "请输入标题或内容",
							type: 'error'
					})
						// loading.close();
				}else{
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$ajax.putJson(serverSrc + qianzui +"/notes/edi_notes",this.$qs.stringify({title: this.bijicanshu.title,content:this.bijicanshu.content,notes_id:this.bijiId}))
					.then((res)=>{
						// this.$set(themedata)
						if(res.data.code!==0){
							this.$message({
								showClose: true,
								message: res.data.message,
								type: 'error'
							})
						}else{
							let query=this.$route.query;
							let lat = query.courseId;
							this.bijishuju()
							this.$message({
								showClose: true,
								message: "修改成功",
								type: 'success'
							})
							this.bijidialogVisible=false
						}
						loading.close();
					})
				}
					
					// loading.close();
			}
		
		},
		// 删除笔记
		delBiji(id){
			var token = this.$cookies.get("token"),
				serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui;
			let query=this.$route.query;
			let lat = query.courseId;
			this.$confirm('此操作将永久删除该笔记, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			// {params:{id:1}}
			this.$ajax.delete(serverSrc + qianzui + "/notes/del_notes",{params:{notes_id:id,course_id:lat}})
			.then((res)=>{
				// console.log(res.data);
				// return false
				if(res.data.code!==0){
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error'
						})
					}else{
						let query=this.$route.query;
						let lat = query.courseId;
						this.bijishuju()
						this.$message({
							showClose: true,
							message: "已删除",
							type: 'success'
						})
						this.bijidialogVisible=false
					}
						// this.bijishuju()
						if((this.bijidata.list.length*this.courseData.score.notes.notes_single_score-2)>=10){
							this.courseData.score.notes.notes_score=10
						}else{
							this.courseData.score.notes.notes_score=this.bijidata.list.length*this.courseData.score.notes.notes_single_score-2
							// this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
						}
						if(this.courseData.score.notes.notes_score==this.courseData.score.notes.notes_total){
							
						}else{
							this.courseData.score.total_score.current_total=(this.courseData.score.total_score.current_total-0)-2
							this.courseData.score.total_score.current_total = this.courseData.score.total_score.current_total.toFixed(1)
							if(this.courseData.score.total_score.current_total > 100){
								this.courseData.score.total_score.current_total = 100
							}
						}
						
					loading.close();
				})
			}).catch(() => {});
		},
		//编辑笔记
		bianjibiji(id){
			this.bijiwancheng=false
			this.bijicanshu.title=''
			this.bijicanshu.content=''
			this.bijiId=id
			this.bijidialogVisible=true
			this.$ajax.get(serverSrc + qianzui + "/notes/detail_notes",{params:{notes_id:id}})
			.then((res)=>{
				// this.bijidialogload = false
				// loading.close()
				this.bijicanshu.title=res.data.data.title
				this.bijicanshu.content=res.data.data.content
				// console.log(res.data);
			})
		},
		// 获取题库练习列表
		get_exercises(){
			let that = this
			this.bank_load = true
			this.$ajax.get(serverSrc + qianzui + "/exercises/exam_group_list",{
				params:{
					course_id: this.cInfo.courseId
				}
			}).then((res)=>{
				this.bank_load = false
				// console.log(res);
				let resData = res.data
				if(resData.code == 0 ){
					that.questionBank = resData.data.filter((v)=>{
                	    return v.exercise.length
                	})
				}else{
					that.$message.error(resData.message);
				}
			})
			// this.$ajax.get(serverSrc + qianzui + "/exercises/list",{
			// 	params:{
			// 		course_id: this.cInfo.courseId
			// 	}
			// }).then((res)=>{
			// 	this.bank_load = false
			// 	let resData = res.data
			// 	if(resData.code == 0 ){
			// 		that.questionBank.simulation = resData.data.simulation
			// 		that.questionBank.real = resData.data.real
			// 		that.questionBank.chapters = resData.data.chapters
			// 	}else{
			// 		that.$message.error(resData.message);
			// 	}
			// })
		},
		// 切换显示的章节练习
		chaptersUp(index){
			this.chapters_show = index
		},
		//题库练习跳转
		join_exercise(item, type){
			//跳转到考试页
			let linl = '/web/courseInfo/exercise'
				,name = 'exercise'
				,test_id = ''
			//根据题库类型修改题库ID
			if(type == "real" || type == "simulation"){
				test_id = item.id
			}else{
				test_id = item.exercise.id
			}
			let data = {
					courseId: this.cInfo.courseId,
					type: type,
					type_id: item.id,
					test_id: test_id
				}
			// if(type == 'chapter'){
			// 	data.test_id = item.exercise.id
			// }
			this.global.join_kaoshi.switch = true
			this.$router.push({
				path: linl,
				name: name,
				query: data,
				params: ''
			})	
		},
		join_wrong_question_book(){
			this.wrong_question_book_dialog = true
		},
		//跳转网页
		window_open(item){
			const loading = this.$loading({
        		lock: true,
        		text: 'Loading',
        		spinner: 'el-icon-loading',
        		background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(serverSrc + qianzui + "/attach/download",this.$qs.stringify({attach_id: item.id, course_id: this.cInfo.courseId})).then((res)=>{
				let resData = res.data
				loading.close();
				if(resData.code == 0 ){
					let pdfsrc = ''
					if(item.path == ""){
						pdfsrc = this.global.serverSrc + this.global.qianzui + "/other/download/" + item.id;		//PDF框路径
					}else{
						pdfsrc = this.global.oss_link + item.path;		//PDF框路径
					}
					window.open(pdfsrc)
				}else{
					this.$message.error(resData.message);
				}
			})
		},
		// 关闭摄像头对话框
		camera_open_hidden(){
			this.camera_open = false
			// 移除本地流
			this.removeStream("videoCamera")
		},
		// 移除本地流
		removeStream(camera){
			if(this.localStream){
				let mediaElement = document.getElementById(camera);
				let stream = mediaElement.srcObject;
				let tracks = stream.getTracks();
				tracks.forEach(function(track) {
					track.stop();
				});
				mediaElement.srcObject = null;
			}
		},
		//上一步/下一步
		set_tab(set){
			if (set=='add') {
                if (this.face_bol) {
                    this.tab_i++
                }
			}else{
				this.tab_i--
			}
		},
		//发起考试认证
		describe_face_verify_request(){
			// 在调用实人认证服务端发起认证请求时需要传入该MetaInfo值
        	var MetaInfo = window.getMetaInfo();
			// console.log(window.getMetaInfo());
			let data = {
				certName:this.exam_name,
				certNo:this.exam_ic,
				metaInfo:MetaInfo,
				// this.global.serverSrc+
				// returnUrl:`http://test.xuexi.qsxueli.com:8981/web/#/web/courseInfo?courseId=${this.cInfo.courseId}&this_test_id=${this.this_test_id}&tab_i=2`,
				returnUrl:this.global.serverSrc+`/web/#/web/courseInfo?courseId=${this.cInfo.courseId}&this_test_id=${this.this_test_id}&tab_i=2`,
				// returnUrl:'https://xuexi.qsxueli.com/web/#/web/name_attestation'
			}
			// console.log(data.returnUrl);
			// return false
			// 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        	if (navigator.mediaDevices === undefined) {
				navigator.mediaDevices = {}
        	}
        	// 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        	// 使用getUserMedia，因为它会覆盖现有的属性。
        	// 这里，如果缺少getUserMedia属性，就添加它。
        	if (navigator.mediaDevices.getUserMedia === undefined) {
				// console.log(6);
				navigator.mediaDevices.getUserMedia = function (constraints) {
					// console.log(7);
					// 首先获取现存的getUserMedia(如果存在)
					var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
					// 有些浏览器不支持，会返回错误信息
					// 保持接口一致
					if (!getUserMedia) {
						// console.log(8);
						return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
					}
					// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
					return new Promise(function (resolve, reject) {
						getUserMedia.call(navigator, constraints, resolve, reject)
					})
				}
        	}
        	var constraints = { audio: false, video: { width: 100, height: 100, transform: 'scaleX(-1)' } }
        	// navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/describe_face_verify_request",this.$qs.stringify(data))
		    	.then(res=>{
					let resData=res.data.data;
					if(resData.Code=='200'){
						window.location.href = resData.ResultObject.CertifyUrl
					}else{
						this.$message.error(resData.MessageText)
					}
					loading.close()
		    	}).catch(e => {
					loading.close()
					console.log(e);
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
        	// }).catch((err) => {
			// 	console.log(err)
			// 	this.camera = 0
			// 	this.$message.error("无法检测到摄像头。如果已经插入摄像头,请允许浏览器使用摄像头的权限")
        	// })
		},
		//人脸比对
		compare_face(url){
			let that = this
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/aliyun/compare_face",{},{
				imagesStream:url,
			})
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
                    if (resData.data.Data.Confidence>70) {
						that.getBase64(null,that.temporarily_url).then(result => {
							that.upLoad(result)
						});
                        that.face_bol = true
                        that.identify_txt = '识别成功'
                    }else{
                        that.identify_txt = '识别失败'
                        that.face_bol = false
                    }
				}else{
                    that.face_bol = false
                    that.identify_txt = '识别失败'
				}
				loading.close()
		    }).catch(e => {
				console.log(e);
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		// 转base64
    	getBase64(file,imgUrl) {
			if (file) {
				// 获取到文件对象
            	var file = file;
            	// 获取FileReader实例
            	var reader = new FileReader();
            	// 将文件加载进入
            	reader.readAsDataURL(file);
	
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					reader.onload = function (e) { 
            		    // 转换完成输出该文件base64编码
						resolve(this.result);
            		}
				});
				return promise
			}else{
				let image = new Image();
      			// 解决跨域问题
      			image.setAttribute("crossOrigin", "anonymous");
      			let imageUrl = imgUrl;
      			image.src = imageUrl;
      			// image.onload为异步加载
      			// eslint-disable-next-line no-undef
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					image.onload = function() {
      				  	var canvas = document.createElement("canvas");
      				  	canvas.width = image.width;
      				  	canvas.height = image.height;
      				  	var context = canvas.getContext("2d");
      				  	// eslint-disable-next-line no-undef
      				  	context.drawImage(image, 0, 0, image.width, image.height);
      				  	var quality = 1;
      				  	// 这里的dataurl就是base64类型
      				  	// 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      				  	let dataurl = canvas.toDataURL("image/jpeg", quality);
      				  	// sBase64 = dataurl
						resolve(dataurl);
      				};
				});
				return promise
			}
			
		},
		//上传
		upLoad(base64){
			let that = this
			let file = that.base64toFile(base64)
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let flname = this.$selfjs.createOssFileName()
			let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${that.user_id}/${flname}.${file.type.split("/")[1]}`;
			//验证通过，上传图片
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+that.user_id}))
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file);
					
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						// console.log(res);
						if (res.ok) {
							that.img_url = upload_path
						}else{
							that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
						}
					})
				}else{
					this.$message.error(resData.message)
				}
				loading.close()
		    }).catch(e => {
				console.log(e);
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		//base64转文件
		base64toFile (dataurl, filename = 'file') {
		    let arr = dataurl.split(',')
		    let mime = arr[0].match(/:(.*?);/)[1]
		    let suffix = mime.split('/')[1]
		    let bstr = atob(arr[1])
		    let n = bstr.length
		    let u8arr = new Uint8Array(n)
		    while (n--) {
		        u8arr[n] = bstr.charCodeAt(n)
		    }
		    return new File([u8arr], `${filename}.${suffix}`, {
		        type: mime
		    })

		},
		//人脸之后跳转考试
		open_text(){
			// let url = `http://test.xuexi.qsxueli.com:8981/web/#/web/courseInfo/test?courseId=${this.cInfo.courseId}&test_id=${this.this_test_id}&img_url=${this.img_url}`
			let url = this.global.serverSrc+`/web/#/web/courseInfo/test?courseId=${this.cInfo.courseId}&test_id=${this.this_test_id}&img_url=${this.img_url}`
			window.location.href = url
		},
		//错题本选择
		wrong_question_book_dialog_fn(){
			//跳转到考试页
			if (this.quantity==0||this.quantity>this.err_quan_sum) {
				this.$message.error('请选择正确的错题数量');
				return false
			}
			let linl = '/web/courseInfo/wrong_question_book'
				,title = this.courseData.course.title
			this.$router.push({
				path: linl,
				title: title,
				query: {
					courseId: this.courseData.course.id,
					quantity: this.quantity,
					test_tit: this.courseData.course.title+' 错题本',
				},
				params: ''
			})	
		},
		//反馈
		notify(){
			this.dialog_feedback = true
			this.feedbackCreated_content.content = ''
			// console.log(item);
		},
		//提交反馈
		notify_click(){
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let url = this.global.serverSrc+this.global.qianzui+'/feedback';
			this.$ajax.post(url,
				this.$qs.stringify({
					title: this.courseData.course.title,
					target_type:2,
					target_id:this.cInfo.courseId,
					content:this.feedbackCreated_content.content
				})).then(res => {
				let resData=res.data;
				// this.loading = false
				if(resData.code==0){
					// 已购课程列表
					this.$message.success('反馈成功');
					this.dialog_feedback = false
					loading.close();
				}
			})
		},
		// 生成两个数之间的随机数
		random_progre(min, max){
			return Math.floor(Math.random() * (max - min + 1)) + min;
		},
		// 关闭视频失焦暂停功能
		close_blur_v(){
			if(this.close_blur_v_n == undefined){
				this.close_blur_v_n = 1
			}else{
				this.close_blur_v_n++
			}
			// 连点10次进度按钮，关闭失焦暂停计时功能
			if(this.close_blur_v_n == 10){
				this.leave_stop_play = false
				console.log('已关闭视频失焦暂停功能！');
				
			}
		},
		// 获取用户课程进度
		get_user_course_study_info(){
			return new Promise((resolve,reject)=>{
				this.$ajax.get("/member/get_user_course_study_info?course_id=" + this.cInfo.courseId)
				.then((res)=>{
					let resData=res.data;
					if(resData.code==0){
						// 更新视频完成情况
						this.course.score.videos.is_finish_video = resData.data.score.videos.is_finish

						resolve(resData.data)
					}else{
						this.$message.error(resData.message)
					}
				})
			})
		},
		// 切换分辨率
		resolution_sw_change(e){
			let val_obj = this.resolution_options.find(v=> v.value == e)
			this.playerOptions.sources[0].type = "video/" + val_obj.format
			this.playerOptions.sources[0].src = val_obj.url
		}
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			let hideType = parseInt(this.$store.state.hideType)
			this.playerOptions.playbackRates = hideType != 3 ? [0.5, 1, 1.5, 2] : []
			return hideType
		},
		//学习时长
		video_study_time(){
			return this.secondsFormat(this.courseData.course.video_study_time, {format:"H时M分"})
		},
		//学习时长
		chapters_study_time(){
			return this.secondsFormat(this.courseData.course.chapters_study_time, {format:"H时M分"})
		},
		//课程视频数据
		course(){
			return this.courseData ? this.courseData : []
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/courseInfo.vue